//region header
//--------------------------------------------------------------------------------------------------
//
//  Description: The main application file used for contexts etc.
//
//  Copyright:    © 2021 - 2026 Idox Software Limited.
//
//--------------------------------------------------------------------------------------------------
//
//  Modification History:
//
//  Version Date     Modifier             Issue# Description
//region Version 1.0.0.0
//    001   16.08.22 Sean Flook          WI39??? Initial Revision.
//    002   16.03.23 Sean Flook          WI40583 Correctly set/reset propertyErrors.
//    003   28.03.23 Sean Flook          WI40632 Added source to HandleWizardDone.
//    004   29.03.23 Sean Flook          WI40634 Do not prevent the map extent from being set due to zoom level.
//    005   06.04.23 Sean Flook          WI40610 Include parentUprn in HandlePropertyValidateData.
//    006   28.06.23 Sean Flook          WI40256 Changed Extent to Provenance where appropriate.
//    007            Sean Flook                  Added newRecord parameter to the HandleStreetRecordChange function.
//    008   17.08.23 Sean Flook        IMANN-156 Modified to allow the login dialog to be displayed again after user has clicked cancel.
//    009   23.08.23 Sean Flook        IMANN-159 Use the new street template structure.
//    010   07.09.23 Sean Flook                  Added code to handle ESU maintenance.
//    011   20.09.23 Sean Flook                  Handle OneScotland specific records types.
//    012   10.10.23 Sean Flook        IMANN-163 Changes required to correctly handle opening the related tab after the property wizard has run.
//    013   12.10.23 Sean Flook                  Added code to deal with storing the expanded ESU and ASD items.
//    014   12.10.23 Sean Flook                  Reset the ESU and ASD list when resetting the street.
//    015   03.11.23 Sean Flook        IMANN-175 Changes required to select properties from the map.
//    016   10.11.23 Sean Flook        IMANN-175 Changes required for Move BLPU seed point.
//    017   20.11.23 Sean Flook                  Removed unwanted code.
//    018   24.11.23 Sean Flook                  Renamed successor to successorCrossRef.
//    019   01.12.23 Sean Flook        IMANN-194 Added HandleUpdateLookup to enable updating a single lookup type.
//    020   14.12.23 Sean Flook                  Corrected note record type and tidied up validation code.
//    021   19.12.23 Sean Flook                  Various bug fixes.
//    022   02.01.24 Sean Flook                  Changed console.log to console.error for error messages.
//    023   05.01.24 Sean Flook                  Use CSS shortcuts.
//    024   10.01.24 Sean Flook        IMANN-163 Added previousStreet and previousProperty.
//    025   12.01.24 Sean Flook        IMANN-163 Search results should be an array.
//    026   25.01.24 Sean Flook                  Changes required after UX review.
//    027   26.01.24 Sean Flook        IMANN-251 Only check why in HandleLeavingStreet.
//    028   05.02.24 Sean Flook                  Further changes required for operational districts.
//    029   13.02.24 Sean Flook                  Pass the authorityCode to ValidatePublicRightOfWayData.
//    030   14.02.24 Sean Flook         ASD10_GP Changes required to filter the ASD map layers when editing a record.
//    031   20.02.24 Sean Flook             MUL1 Changes required for handling selecting properties from the map.
//    032   26.02.24 Joel Benford      IMANN-242 Add DbAuthority to lookups context
//    033   27.02.24 Sean Flook            MUL16 Added ability too hide the search control.
//    034   05.03.24 Sean Flook        IMANN-338 Store the last opened street and property tab.
//    035   08.03.24 Sean Flook        IMANN-348 If clearing ESU from sandbox ensure highway dedication and one way exemption are also cleared.
//    036   11.03.24 Sean Flook            GLB12 Use appBarHeight to set the height of the control.
//    037   13.03.24 Sean Flook             MUL9 Changes required to enable related refresh.
//    038   04.04.24 Sean Flook                  Added navigate back and leaving a property.
//    039   05.04.24 Sean Flook        IMANN-351 Changes to handle browser navigation.
//    040   09.04.24 Sean Flook                  If we do not have user information do not close the login dialog.
//    041   11.04.24 Sean Flook                  Use title case for authority name rather than sentence case.
//    042   16.04.24 Sean Flook                  Changes required to handle loading and displaying SHP files.
//    043   18.04.24 Sean Flook        IMANN-351 Changes required to reload the contexts after a refresh.
//    044   30.04.24 Sean Flook        IMANN-371 Separate out streetTab and propertyTab.
//    045   01.05.24 Sean Flook                  Only reload contexts if required.
//    046   14.05.24 Joshua McCormick  IMANN-270 Typo in Validation  for errors with hww & prow
//    047   14.05.24 Sean Flook        IMANN-206 Changes required to display all the provenances.
//    048   30.05.24 Sean Flook        IMANN-499 Include settingsNode in the settingsContext reload.
//    049   04.06.24 Sean Flook        IMANN-510 Include the level field when validating the BLPU data.
//    050   04.06.24 Sean Flook        IMANN-511 Handle when we do not have an internet connection.
//    051   06.06.24 Sean Flook        IMANN-524 Ensure the sandbox has the current data.
//    052   12.06.24 Sean Flook        IMANN-536 Added some additional checking to HandleMapReload.
//    053   12.06.24 Sean Flook        IMANN-565 Handle polygon deletion.
//    054   19.06.24 Sean Flook        IMANN-629 Changes to code so that current user is remembered and a 401 error displays the login dialog.
//    055   20.06.24 Sean Flook        IMANN-636 Bug fix.
//    056   24.06.24 Sean Flook        IMANN-170 Changes required for cascading parent PAO changes to children.
//    057   01.07.24 Sean Flook        IMANN-592 Use sandboxRef.current in HandleResetSandbox.
//    058   04.07.24 Sean Flook        IMANN-705 Added displayName to contextUser.
//    059   08.07.24 Sean Flook        IMANN-728 Include the new user rights.
//    060   17.07.24 Sean Flook        IMANN-596 Modified HandleClearHighlight to set objects to empty arrays rather than null.
//    061   19.07.24 Sean Flook        IMANN-801 Added polling objects to Offline and Online and changed the polling interval from every 5 seconds to every 60 seconds.
//    062   23.07.24 Sean Flook        IMANN-801 Reduced the polling interval back to every 5 seconds.
//    063   06.08.24 Sean Flook        IMANN-903 Use a reference to store the loaded SHP files.
//    064   27.08.24 Sean Flook        IMANN-925 Corrected typo.
//    065   10.09.24 Sean Flook        IMANN-980 Set the showMessages rights for users and only write to the console if the user has the showMessages right.
//endregion Version 1.0.0.0
//region Version 1.0.1.0
//    066   26.09.24 Sean Flook        IMANN-573 Updated the version.
//    067   14.10.24 Sean Flook       IMANN-1016 Changes required to handle LLPG Streets.
//    068   28.10.24 Sean Flook       IMANN-1040 Clear the localStorage and sessionStorage items when logoff user.
//    069   28.10.24 Joshua McCormick  IMANN-904 added context for clearObject, setClearObject
//    070   05.11.24 Sean Flook        IMANN-904 Correctly handle clearing the geometry in HandleSetLineGeometry.
//    071   06.11.24 Sean Flook       IMANN-1047 Undo changes done for IMANN-904.
//endregion Version 1.0.1.0
//region Version 1.0.2.0
//    066   13.11.24 Sean Flook       IMANN-1012 Updated the version.
//    067   27.11.24 Sean Flook       IMANN-1096 Do not store the lookups in the session storage.
//endregion Version 1.0.2.0
//region Version 1.0.3.0
//    068   02.01.25 Sean Flook       IMANN-1121 Updated the version.
//    069   07.01.25 Sean Flook       IMANN-1124 When opening the related tab always include the current property in the expand list.
//    070   09.01.25 Sean Flook       IMANN-1125 Moved code to prevent the calls to get the background data from being run multiple times.
//    071   13.01.25 Sean Flook       IMANN-1136 Various changes to improve editing provenances.
//    072   16.01.25 Sean Flook       IMANN-1136 Removed editingProvenance and changed provenanceMerged to provenanceMerging.
//endregion Version 1.0.3.0
//region Version 1.0.4.0
//    073   03.02.25 Sean Flook       IMANN-1676 Updated the version.
//    074   04.02.25 Sean Flook       IMANN-1674 Use the same zoom level for background streets and properties.
//    075   06.02.25 Sean Flook       IMANN-1679 If authorisation has expired display the home page.
//    076   12.02.25 Sean Flook       IMANN-1684 Changes required to set the map extent to the authorities extent when returning to the gazetteer page with no search results.
//endregion Version 1.0.4.0
//region Version 1.0.5.0
//    077   22.01.25 Sean Flook       IMANN-1077 Updated the version.
//    078   30.01.25 Sean Flook       IMANN-1673 Changes required for new user settings API.
//    079   17.03.25 Sean Flook       IMANN-1711 Added metadataLanguages to the settings context.
//    080   18.03.25 Sean Flook       IMANN-1695 Set the point capture mode when selecting properties from the map.
//    081   19.03.25 Sean Flook       IMANN-1695 Tidied up code in HandleAuthorityDetailsChange.
//    082   22.04.25 Joshua McCormick IMANN-1743 Commented out all sessionStorage calls
//    083   24.04.25 Sean Flook       IMANN-1760 Reenabled above change as required.
//    084   23.05.25 Peter Bryden     IMANN-1792 Added check into HandleRestoreStreet to only restore if not an empty default
//    085   27.05.25 Sean Flook       IMANN-1792 Corrected check in HandleRestoreStreet.
//endregion Version 1.0.5.0
//region Version 1.0.6.0
//    086   11.07.25 Sean Flook       IMANN-1855 Changes to handle errors from bulk updates.
//    087   17.07.25 Sean Flook       IMANN-1864 Removed streetDescriptors from the lookups context.
//    088   25.07.25 Sean Flook                  Updated the version to 1.0.6.0.
//    089   05.08.25 Sean Flook       IMANN-1932 Added saveClicked to sandboxContext.
//    090   18.08.25 Sean Flook       IMANN-1996 Pass the correct information to GetPropertyFromUPRNUrl.
//endregion Version 1.0.6.0
//region Version 1.0.6.1
//    091   01.09.25 Sean Flook       IMANN-2008 Updated version to 1.0.6.1.
//endregion Version 1.0.6.1
//region Version 1.0.6.4
//    092   01.10.25 Sean Flook       IMANN-2077 Use -1 rather than 0 for new streets.
//endregion Version 1.0.6.4
//region Version 1.0.7.0
//    093   13.06.25 Sean Flook       IMANN-1812 Modified to use the new Sandbox store.
//    094   22.08.25 Sean Flook       IMANN-1812 Fixed merge issues.
//    095   28.08.25 Sean Flook       IMANN-1812 Changes required to update MUI to v7.
//    096   28.08.25 Sean Flook       IMANN-1812 Changes required to update MUI X to v8.
//    097   01.09.25 Sean Flook       IMANN-1812 Changes required to update React-Router-Dom to v6.
//    098   04.09.25 Sean Flook       IMANN-1812 Changes required to update React-Router-Dom to v7.
//    099   04.09.25 Sean Flook       IMANN-1812 Changes required to replace React-Router-Dom with React_Router v7.8.2.
//    100   10.09.25 Sean Flook       IMANN-1812 Changes required to implement basemap gallery.
//    101   15.09.25 Sean Flook       IMANN-1812 Only reset the basemap gallery when the auditname changes.
//    102   16.09.25 Sean Flook       IMANN-1962 Removed layerVisibility from mapContext as no longer needed.
//    103   24.09.25 Sean Flook       IMANN-1031 Changed updatingMap to be numeric.
//    104   24.10.25 Sean Flook       IMANN-1129 Modified HandleLoadShpFile to handle layer files and getting the required information for the map layer.
//    105   24.10.25 Sean Flook       IMANN-2097 Changes required to load georeferenced image files.
//    106   27.10.25 Sean Flook       IMANN-2092 Added spatialReferenceWkid to mapContext to allow for different spatial reference systems.
//    107   03.11.25 Sean Flook       IMANN-2073 Modified HandleMapChange to handle zooming to a group of properties and streets.
//    108   07.11.25 Sean Flook       IMANN-2097 Changes required to load georeferenced image file and world file.
//    109   24.11.25 Sean Flook       IMANN-2147 Changes required for validation.
//    110   24.11.25 Sean Flook       IMANN-2147 Ensure the localCustodianCode is included when validating the BLPU data.
//    111   05.12.25 Sean Flook       IMANN-1671 Code added to refresh the provenance geometry.
//    112   05.12.25 Sean Flook       IMANN-2190 Added useSearchExtent to mapContext to flag whether to use the search results when setting the map extent or not.
//    113   17.12.25 Sean Flook       IMANN-2196 Added selectionContext to handle the selection control within the maps.
//    114   17.12.25 Sean Flook       IMANN-1705 Added refreshSketchLayer to mapContext to handle refreshing the sketch layer and set to true when we set the map edit object.
//    115   23.01.26 Sean Flook       IMANN-2206 Need to clear out the map extent and background data when a new search is performed.
//    116   27.01.26 Sean Flook       IMANN-2238 Added code to restore a street after creating a property from the street.
//    117   28.01.26 Sean Flook       IMANN-2215 Initialise the zoomGroup of map to null rather than undefined.
//    118   29.01.26 Sean Flook       IMANN-2257 Show the undo and redo menu when creating a polygon.
//    119   29.01.26 Sean Flook       IMANN-2258 Added hideSketchDeleteButton to sketchToolVisibility and set when required.
//    120   11.02.26 Sean Flook       IMANN-2282 Use -1 for USRN for new streets.
//    121   12.02.26 Sean Flook       IMANN-2218 Correctly handle when UPRN is a string when determining page to navigate to.
//    122   18.02.26 Sean Flook       IMANN-2327 Prevent updatingMap from going below 0.
//    123   19.02.26 Sean Flook       IMANN-2330 Changed iManage Cloud to iManage GMS.
//    124   20.02.26 Sean Flook       IMANN-2329 Added ability to store range property errors.
//    125   20.02.26 Sean Flook       IMANN-2329 Removed debug messages.
//    126   24.02.26 Sean Flook       IMANN-2340 Only set updatingProvenance if we are not deleting the extent.
//    127   26.02.26 Sean Flook       IMANN-2324 Various changes to reload functions to ensure the data is correctly reloaded.
//    128   26.02.26 Sean Flook       IMANN-2341 Correctly handle ESU geometry removal.
//    129   06.03.26 Sean Flook       IMANN-2109 Renamed the map context property currentSearchData to currentMapSearchData to better reflect its purpose.
//    130   18.03.26 Sean Flook       IMANN-2212 Added variables and methods used to reload SHP and georeferenced image files.
//    131   25.03.26 Sean Flook       IMANN-2370 Added some error handling.
//    132   07.04.26 Sean Flook       IMANN-2395 Use reference variables when using within methods.
//    133   15.04.26 Sean Flook       IMANN-2097 Set addGeoFilesToMap to true when adding georeferenced image files.
//    134   20.04.26 Sean Flook       IMANN-2397 Only clear the map extent if the search has changed.
//endregion Version 1.0.7.0
//region Version 1.0.7.1
//    135   23.04.26 Sean Flook       IMANN-2408 Increased version.
//    136   27.04.26 Sean Flook       IMANN-2411 Correctly compare UPRNs.
//    137   27.04.26 Sean Flook       IMANN-2413 If we do not have the current zoom look at the distance between the max and min coordinates to determine if we should get the background data or not.
//    138   28.04.26 Sean Flook       IMANN-2415 Removed useSearchExtent as not required.
//endregion Version 1.0.7.1
//region Version 1.0.7.2
//    139   01.05.26 Sean Flook       IMANN-2422 Changes required for being able to edit an ESU correctly and increased version.
//    140   01.05.26 Sean Flook       IMANN-2429 Added flag for a new property record type.
//    141   06.05.26 Sean Flook       IMANN-2436 Added flag for ESU checked and ensure ESU refresh is false when opening a new ESU.
//    142   08.05.26 Sean Flook       IMANN-2441 Removed the displayMapWizard state as it is no longer required.
//    143   11.05.26 Sean Flook       IMANN-2442 Added onClearWizardData to clear the wizard data after it has been used.
//    144   18.05.26 Sean Flook       IMANN-2446 Added manuallySetStartEnd to street error fields.
//    145   02.06.26 Sean Flook       IMANN-2460 Undo changes made for IMANN-2441 and when closing the wizard map reset the selection variant.
//endregion Version 1.0.7.2
//
//--------------------------------------------------------------------------------------------------
//endregion header

import React, { useState, useRef, Fragment, useEffect } from "react";
import { useNavigate, Outlet } from "react-router";

import useSandboxStore from "./context/SandboxStore";

import userContext from "./context/userContext";
import LookupContext from "./context/lookupContext";
import SearchContext from "./context/searchContext";
import FilterContext from "./context/filterContext";
import SettingsContext from "./context/settingsContext";
import StreetContext from "./context/streetContext";
import PropertyContext from "./context/propertyContext";
import MapContext from "./context/mapContext";
import InformationContext from "./context/informationContext";
import SelectionContext from "./context/selectionContext";

import {
  GetAdministrativeAreaUrl,
  GetAppCrossRefUrl,
  GetBackgroundPropertiesUrl,
  GetBackgroundProvenancesUrl,
  GetBackgroundStreetsUrl,
  GetDbAuthorityUrl,
  GetIslandUrl,
  GetLocalityUrl,
  GetOperationalDistrictUrl,
  GetParishesUrl,
  GetPostTownUrl,
  GetPropertyFromUPRNUrl,
  GetSearchURL,
  GetSubLocalityUrl,
  GetTownUrl,
  GetUnassignedEsusUrl,
  GetValidationMessagesUrl,
  GetWardsUrl,
} from "./configuration/ADSConfig";
import { hasLoginExpired, mapSelectSearchString, mergeArrays, StringToTitleCase } from "./utils/HelperUtils";
import { GetSearchStreetMapData } from "./utils/StreetUtils";
import {
  ValidateStreetData,
  ValidateDescriptorData,
  ValidateEsuData,
  ValidateOneWayExemptionData,
  ValidateHighwayDedicationData,
  ValidateMaintenanceResponsibilityData,
  ValidateReinstatementCategoryData,
  ValidateOSSpecialDesignationData,
  ValidateInterestData,
  ValidateConstructionData,
  ValidateSpecialDesignationData,
  ValidateHeightWidthWeightData,
  ValidatePublicRightOfWayData,
  ValidateStreetNoteData,
} from "./utils/StreetValidation";
import {
  ValidateBlpuData,
  ValidateLpiData,
  ValidateProvenanceData,
  ValidateCrossRefData,
  ValidateClassificationData,
  ValidateOrganisationData,
  ValidateSuccessorCrossRefData,
  ValidatePropertyNoteData,
} from "./utils/PropertyValidation";

import ADSAppBar from "./components/ADSAppBar";
import ADSNavContent from "./components/ADSNavContent";
import { Offline, Online } from "react-detect-offline";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV2";
import { Typography, Box, Stack } from "@mui/material";
import LoginDialog from "./dialogs/LoginDialog";

import DETRCodes from "./data/DETRCodes";

import WifiOffIcon from "@mui/icons-material/WifiOff";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { SaveConfirmationServiceProvider } from "./pages/SaveConfirmationPage";

import { ThemeProvider, StyledEngineProvider, createTheme } from "@mui/material/styles";
import { appBarHeight } from "./utils/ADSStyles";
import { adsLightGreyD } from "./utils/ADSColours";
import CssBaseline from "@mui/material/CssBaseline";
import "./App.css";

function App() {
  const theme = createTheme();

  const currentStreet = useSandboxStore((state) => state.currentStreet);
  const currentEsuRecord = useSandboxStore((state) => state.currentEsuRecord);
  const currentDescriptorRecord = useSandboxStore((state) => state.currentDescriptorRecord);
  const currentOneWayExemptionRecord = useSandboxStore((state) => state.currentOneWayExemptionRecord);
  const currentHighwayDedicationRecord = useSandboxStore((state) => state.currentHighwayDedicationRecord);
  const currentMaintenanceResponsibilityRecord = useSandboxStore(
    (state) => state.currentMaintenanceResponsibilityRecord
  );
  const currentReinstatementCategoryRecord = useSandboxStore((state) => state.currentReinstatementCategoryRecord);
  const currentOSSpecialDesignationRecord = useSandboxStore((state) => state.currentOSSpecialDesignationRecord);
  const currentInterestRecord = useSandboxStore((state) => state.currentInterestRecord);
  const currentConstructionRecord = useSandboxStore((state) => state.currentConstructionRecord);
  const currentSpecialDesignationRecord = useSandboxStore((state) => state.currentSpecialDesignationRecord);
  const currentHWWRecord = useSandboxStore((state) => state.currentHWWRecord);
  const currentPRoWRecord = useSandboxStore((state) => state.currentPRoWRecord);
  const currentStreetNoteRecord = useSandboxStore((state) => state.currentStreetNoteRecord);
  const currentProperty = useSandboxStore((state) => state.currentProperty);
  const currentProvenanceRecord = useSandboxStore((state) => state.currentProvenanceRecord);
  const currentAppCrossRefRecord = useSandboxStore((state) => state.currentAppCrossRefRecord);
  const currentLpiRecord = useSandboxStore((state) => state.currentLpiRecord);
  const currentSuccessorCrossRefRecord = useSandboxStore((state) => state.currentSuccessorCrossRefRecord);
  const currentOrganisationRecord = useSandboxStore((state) => state.currentOrganisationRecord);
  const currentClassificationRecord = useSandboxStore((state) => state.currentClassificationRecord);
  const currentPropertyNoteRecord = useSandboxStore((state) => state.currentPropertyNoteRecord);

  let navigate = useNavigate();

  const [currentUser, setCurrentUser] = useState(null);
  const currentUserRef = useRef(null);
  const userShowMessages = useRef(false);

  const [loginOpen, setLoginOpen] = useState(localStorage.getItem("currentUser") === null);
  const loginMessage = useRef("Enter your credentials.");

  const currentMapExtent = useRef(null);

  const guiVersion = "1.0.7.2";

  const onlinePolling = { enabled: true, url: "https://ipv4.icanhazip.com", interval: 5000, timeout: 5000 };
  const offlinePolling = { enabled: true, url: "https://ipv4.icanhazip.com", interval: 5000, timeout: 5000 };

  const [lookups, setLookups] = useState({
    validationMessages: [],
    localities: [],
    towns: [],
    islands: [],
    adminAuthorities: [],
    operationalDistricts: [],
    appCrossRefs: [],
    subLocalities: [],
    streetDescriptors: [],
    postTowns: [],
    wards: [],
    parishes: [],
    dbAuthorities: [],
  });

  const [reloadingLookups, setReloadingLookups] = useState(false);
  const [lookupValidationMessages, setLookupValidationMessages] = useState();
  const [lookupLocalities, setLookupLocalities] = useState();
  const [lookupIslands, setLookupIslands] = useState();
  const [lookupTowns, setLookupTowns] = useState();
  const [lookupAdminAuthorities, setLookupAdminAuthorities] = useState();
  const [lookupOperationalDistricts, setLookupOperationalDistricts] = useState();
  const [lookupAppCrossRefs, setLookupAppCrossRefs] = useState();
  const [lookupSubLocalities, setLookupSubLocalities] = useState();
  const [lookupPostTowns, setLookupPostTowns] = useState();
  const [lookupWards, setLookupWards] = useState();
  const [lookupParishes, setLookupParishes] = useState();
  const [lookupDbAuthorities, setLookupDbAuthorities] = useState();

  const loadedLookups = useRef([]);
  const validationMessagesLoaded = useRef(false);
  const localitiesLoaded = useRef(false);
  const islandsLoaded = useRef(false);
  const townsLoaded = useRef(false);
  const adminAuthoritiesLoaded = useRef(false);
  const operationalDistrictsLoaded = useRef(false);
  const appCrossRefsLoaded = useRef(false);
  const subLocalitiesLoaded = useRef(false);
  const postTownsLoaded = useRef(false);
  const wardsLoaded = useRef(false);
  const parishesLoaded = useRef(false);
  const dbAuthoritiesLoaded = useRef(false);

  const [metadata, setMetadata] = useState(null);

  const [districtUpdated, setDistrictUpdated] = useState(false);

  const [searchData, setSearchData] = useState({
    searchString: "!+reload+!",
    results: [],
  });

  const [previousSearchData, setPreviousSearchData] = useState({
    searchString: searchData.searchString,
    results: searchData.results,
  });

  const [searchOpen, setSearchOpen] = useState(false);
  const [hideSearch, setHideSearch] = useState(false);
  const [navigateBack, setNavigateBack] = useState(false);

  const [searchFilter, setSearchFilter] = useState({});

  const [settingsNode, setSettingsNode] = useState("");

  const [authorityDetails, setAuthorityDetails] = useState({
    userOrgName: null,
    dataProviderCode: null,
    msaLicenceNumber: null,
    tabText: null,
    minusrn: 0,
    maxusrn: 0,
    minuprn: 0,
    maxuprn: 0,
    minesuId: 0,
    maxesuId: 0,
    streetBlpu: false,
    displayLanguage: "ENG",
  });

  const [authorityCode, setAuthorityCode] = useState(0);

  const [authorityName, setAuthorityName] = useState("");

  const [isScottish, setIsScottish] = useState(false);
  const isScottishRef = useRef(false);

  const [isWelsh, setIsWelsh] = useState(false);
  const isWelshRef = useRef(false);

  const [propertyTemplates, setPropertyTemplates] = useState([]);

  const [streetTemplate, setStreetTemplate] = useState({
    pkId: 1,
    templateName: "Street template",
    templateDescription: "Set default lookup values for streets.",
    templateType: 0,
    templateUseType: 0,
    numberingSystem: 0,
    constructionTemplate: null,
    esuTemplate: null,
    heightWidthWeightTemplate: null,
    interestTemplate: null,
    publicRightOfWayTemplate: null,
    scoEsuTemplate: null,
    scoMaintenanceResponsibilityTemplate: null,
    scoReinstatementCategoryTemplate: null,
    scoSpecialDesignationTemplate: null,
    specialDesignationTemplate: null,
    streetTemplate: null,
  });

  const [mapLayers, setMapLayers] = useState(null);
  const [metadataLanguages, setMetadataLanguages] = useState({ street: "ENG", asd: "ENG", property: "ENG" });

  const [street, setStreet] = useState({
    usrn: -1,
    descriptor: "!+reload+!",
    newStreet: false,
    openRelated: null,
  });

  const previousStreet = useRef({
    usrn: -1,
    descriptor: "",
    newStreet: false,
    openRelated: null,
  });

  const [streetRestored, setStreetRestored] = useState(false);

  const [streetErrors, setStreetErrors] = useState({
    street: [],
    descriptor: [],
    esu: [],
    highwayDedication: [],
    oneWayExemption: [],
    successorCrossRef: [],
    interest: [],
    maintenanceResponsibility: [],
    reinstatementCategory: [],
    osSpecialDesignation: [],
    construction: [],
    specialDesignation: [],
    heightWidthWeight: [],
    publicRightOfWay: [],
    note: [],
  });

  const [creatingStreet, setCreatingStreet] = useState(false);

  const [streetHasErrors, setStreetHasErrors] = useState(false);

  const [leavingStreet, setLeavingStreet] = useState(null);

  const [streetModified, setStreetModified] = useState(false);

  const [streetClosing, setStreetClosing] = useState(false);

  const [streetGoToField, setStreetGoToField] = useState(null);

  const [streetRecord, setStreetRecord] = useState({
    type: 11,
    id: null,
    index: null,
    parentIndex: null,
    newRecord: false,
  });

  const [esuDataChanged, setEsuDataChanged] = useState(false);

  const [esuChecked, setEsuChecked] = useState([]);
  const [selectedMapEsuId, setSelectedMapEsuId] = useState(null);
  const [mergedEsus, setMergedEsus] = useState(null);
  const [unassignEsus, setUnassignEsus] = useState(null);
  const [assignEsu, setAssignEsu] = useState(null);
  const [assignEsus, setAssignEsus] = useState(null);
  const [createEsus, setCreateEsus] = useState(null);
  const [esuDividedMerged, setEsuDividedMerged] = useState(false);
  const [expandedEsu, setExpandedEsu] = useState([]);
  const [expandedAsd, setExpandedAsd] = useState([]);

  const [property, setProperty] = useState({
    uprn: 0,
    usrn: -1,
    address: "",
    formatAddress: "",
    postcode: "",
    easting: 0,
    northing: 0,
    newProperty: false,
    parent: null,
    openRelated: null,
  });

  const previousProperty = useRef({
    uprn: 0,
    usrn: -1,
    address: "",
    formatAddress: "",
    postcode: "",
    easting: 0,
    northing: 0,
    newProperty: false,
    parent: null,
    openRelated: null,
  });

  const [propertyErrors, setPropertyErrors] = useState({
    pkId: null,
    blpu: [],
    lpi: [],
    provenance: [],
    crossRef: [],
    classification: [],
    organisation: [],
    successorCrossRef: [],
    note: [],
  });
  const [rangePropertyErrors, setRangePropertyErrors] = useState([]);
  const rangePropertyErrorsRef = useRef([]);

  const [bulkUpdatePropertiesError, setBulkUpdatePropertiesError] = useState([]);

  const [propertyHasErrors, setPropertyHasErrors] = useState(false);

  const [leavingProperty, setLeavingProperty] = useState(null);

  const [propertyModified, setPropertyModified] = useState(false);

  const [logicalStatus, setLogicalStatus] = useState(null);

  const [propertyGoToField, setPropertyGoToField] = useState(null);

  const [propertyRecord, setPropertyRecord] = useState({
    type: 21,
    index: null,
  });

  const [childCount, setChildCount] = useState(0);

  const [provenanceDataChanged, setProvenanceDataChanged] = useState(false);

  const [wizardData, setWizardData] = useState(null);

  const [creatingPropertyRange, setCreatingPropertyRange] = useState(false);
  const creatingPropertyRangeRef = useRef(false);

  const [newPropertyRecordType, setNewPropertyRecordType] = useState(false);

  const [spatialReferenceWkid, setSpatialReferenceWkid] = useState(27700);

  const [backgroundData, setBackgroundData] = useState({
    streets: [],
    unassignedEsus: [],
    properties: [],
    provenances: [],
  });

  const [mapSearchData, setMapSearchData] = useState({
    streets: [],
    llpgStreets: [],
    properties: [],
    editStreet: null,
    editProperty: null,
  });

  const previousStreetMapSearchData = useRef({
    streets: [],
    llpgStreets: [],
    properties: [],
    editStreet: null,
    editProperty: null,
  });

  const [sourceMapSearchData, setSourceMapSearchData] = useState({
    streets: [],
    llpgStreets: [],
    properties: [],
  });

  const [map, setMap] = useState({
    extents: [],
    zoomStreet: null,
    zoomProperty: null,
    zoomGroup: null,
  });

  const [editObject, setEditObject] = useState(null);
  const [mapProperty, setMapProperty] = useState(null);
  const [mapStreet, setMapStreet] = useState(null);
  const [mapExtent, setMapExtent] = useState(null);

  const [highlight, setHighlight] = useState({
    street: null,
    esu: null,
    asd51: null,
    asd52: null,
    asd53: null,
    asd61: null,
    asd62: null,
    asd63: null,
    asd64: null,
    asd66: null,
    property: null,
    selectProperties: null,
    extent: null,
  });

  const [mapPropertyPin, setMapPropertyPin] = useState(null);
  const [mapStreetStart, setMapStreetStart] = useState(null);
  const [mapStreetEnd, setMapStreetEnd] = useState(null);
  const [mapDivideEsu, setMapDivideEsu] = useState(null);
  const [mapLineGeometry, setMapLineGeometry] = useState(null);
  const [mapPolygonGeometry, setMapPolygonGeometry] = useState(null);
  const [wizardPoint, setWizardPoint] = useState(null);
  const [selectingProperties, setSelectingProperties] = useState(false);
  const [loadedShpFiles, setLoadedShpFiles] = useState([]);
  const [loadedGeoFiles, setLoadedGeoFiles] = useState([]);
  const currentShpFiles = useRef([]);
  const currentGeoFiles = useRef([]);
  const [addShpFilesToMap, setAddShpFilesToMap] = useState(false);
  const [addGeoFilesToMap, setAddGeoFilesToMap] = useState(false);
  const [updatingEsuGeometry, setUpdatingEsuGeometry] = useState(false);
  const [refreshEsuGeometry, setRefreshEsuGeometry] = useState(false);
  const [updatingProvenance, setUpdatingProvenance] = useState(false);
  const [refreshProvenance, setRefreshProvenance] = useState(false);
  const [createToolActivated, setCreateToolActivated] = useState(false);
  const [viewAuthorityExtent, setViewAuthorityExtent] = useState(false);
  const [updatingMap, setUpdatingMap] = useState(0);
  const [sketchToolVisibility, setSketchToolVisibility] = useState({
    hideSketch: true,
    hideSketchLassoSelection: true,
    hideSketchRectangleSelection: true,
    hideSketchUndoRedoMenu: true,
    hideSketchDeleteButton: true,
  });
  const [displayingWizardMap, setDisplayingWizardMap] = useState(false);
  const [activeBaseMap, setActiveBaseMap] = useState(null);
  const [refreshSketchLayer, setRefreshSketchLayer] = useState(false);

  const [pointCaptureMode, setPointCaptureMode] = useState(null);
  const [selectedPin, setSelectedPin] = useState(null);
  const pointCaptureModeRef = useRef(null);
  const editObjectRef = useRef(null);

  const [informationType, setInformationType] = useState(null);
  const [informationSource, setInformationSource] = useState(null);

  const [selectionVariant, setSelectionVariant] = useState("");
  const selectionVariantRef = useRef("");
  const previousSelectionVariantRef = useRef("");
  const [selectionCount, setSelectionCount] = useState(0);
  const [dialogSelectionCount, setDialogSelectionCount] = useState(0);
  const [currentStreetSelection, setCurrentStreetSelection] = useState([]);
  const [currentEsuSelection, setCurrentEsuSelection] = useState([]);
  const [currentPropertySelection, setCurrentPropertySelection] = useState([]);
  const [currentAddressSelection, setCurrentAddressSelection] = useState("");
  const [currentClassificationSelection, setCurrentClassificationSelection] = useState([]);
  const [currentOrganisationSelection, setCurrentOrganisationSelection] = useState([]);
  const [currentSuccessorCrossRefSelection, setCurrentSuccessorCrossRefSelection] = useState([]);
  const [currentProvenanceSelection, setCurrentProvenanceSelection] = useState([]);
  const [currentExtentSelection, setCurrentExtentSelection] = useState([]);
  const [currentCrossReferenceSelection, setCurrentCrossReferenceSelection] = useState([]);
  const [streetUsrns, setStreetUsrns] = useState([]);
  const [propertyUprns, setPropertyUprns] = useState([]);
  const [copyOpen, setCopyOpen] = useState(null);
  const [addNote, setAddNote] = useState(false);
  const [editWizard, setEditWizard] = useState("");
  const [selectionError, setSelectionError] = useState(false);
  const [deleteClassification, setDeleteClassification] = useState(false);
  const [deleteOrganisation, setDeleteOrganisation] = useState(false);
  const [deleteSuccessorCrossRef, setDeleteSuccessorCrossRef] = useState(false);
  const [deleteProvenance, setDeleteProvenance] = useState(false);
  const [mergeExtent, setMergeExtent] = useState(false);
  const [deleteCrossReference, setDeleteCrossReference] = useState(false);
  const [deleteWizard, setDeleteWizard] = useState(false);
  const [propertyMoved, setPropertyMoved] = useState(false);
  const [closeControl, setCloseControl] = useState(false);

  //region userContext
  /**
   * Event to handle when the user changes.
   *
   * @param {object} userInfo The users information.
   */
  function HandleUserChange(userInfo) {
    if (userInfo) {
      userShowMessages.current =
        userInfo.active &&
        userInfo.extraInformation &&
        userInfo.extraInformation.length > 0 &&
        !!userInfo.extraInformation.find((x) => x.key === "ShowMessages" && x.value === "true");

      const user = {
        ...userInfo,
        displayName: `${userInfo.firstName} ${userInfo.lastName}`.trim(),
        isAdministrator:
          userInfo.active &&
          (userInfo.rights.includes("LSGAdministrator") ||
            userInfo.rights.includes("ASDAdministrator") ||
            userInfo.rights.includes("LLPGAdministrator")),
        hasStreet:
          userInfo.active &&
          (userInfo.rights.includes("LSGReadOnly") ||
            userInfo.rights.includes("LSGEditor") ||
            userInfo.rights.includes("LSGAdministrator")),
        hasASD:
          userInfo.active &&
          (userInfo.rights.includes("ASDReadOnly") ||
            userInfo.rights.includes("ASDEditor") ||
            userInfo.rights.includes("ASDAdministrator")),
        hasProperty:
          userInfo.active &&
          (userInfo.rights.includes("LLPGReadOnly") ||
            userInfo.rights.includes("LLPGEditor") ||
            userInfo.rights.includes("LLPGAdministrator")),
        editStreet:
          userInfo.active && (userInfo.rights.includes("LSGEditor") || userInfo.rights.includes("LSGAdministrator")),
        adminStreet: userInfo.active && userInfo.rights.includes("LSGAdministrator"),
        editASD:
          userInfo.active && (userInfo.rights.includes("ASDEditor") || userInfo.rights.includes("ASDAdministrator")),
        adminASD: userInfo.active && userInfo.rights.includes("ASDAdministrator"),
        editProperty:
          userInfo.active && (userInfo.rights.includes("LLPGEditor") || userInfo.rights.includes("LLPGAdministrator")),
        adminProperty: userInfo.active && userInfo.rights.includes("LLPGAdministrator"),
        showMessages: userShowMessages.current,
      };

      setCurrentUser(user);
      currentUserRef.current = user;
      if (loginOpen) setLoginOpen(false);
      localStorage.setItem("currentUser", JSON.stringify(user));
      if (
        localStorage.getItem("currentAuditname") !== null &&
        userInfo.auditName !== localStorage.getItem("currentAuditname")
      ) {
        localStorage.removeItem("currentBaseMapId");
        setActiveBaseMap(null);
      }
      localStorage.setItem("currentAuditname", userInfo.auditName);
    } else {
      setCurrentUser(null);
      currentUserRef.current = null;
      localStorage.removeItem("currentUser");

      sessionStorage.removeItem("authorityDetails");
      sessionStorage.removeItem("editObject");
      sessionStorage.removeItem("esu");
      sessionStorage.removeItem("expandedAsd");
      sessionStorage.removeItem("expandedEsu");
      sessionStorage.removeItem("displayInformation");
      sessionStorage.removeItem("GazetteerPage_firstLoadDone");
      sessionStorage.removeItem("map");
      sessionStorage.removeItem("mapExtent");
      sessionStorage.removeItem("mapLayers");
      sessionStorage.removeItem("metadata");
      sessionStorage.removeItem("property");
      sessionStorage.removeItem("propertyChildCount");
      sessionStorage.removeItem("propertyErrors");
      sessionStorage.removeItem("PropertyPage_firstLoadDone");
      sessionStorage.removeItem("propertyRecord");
      sessionStorage.removeItem("propertyTab");
      sessionStorage.removeItem("propertyTemplates");
      sessionStorage.removeItem("sandbox");
      sessionStorage.removeItem("settingsNode");
      sessionStorage.removeItem("SettingsPage_firstLoadDone");
      sessionStorage.removeItem("street");
      sessionStorage.removeItem("streetErrors");
      sessionStorage.removeItem("StreetPage_ApiUrl");
      sessionStorage.removeItem("StreetPage_firstLoadDone");
      sessionStorage.removeItem("streetRecord");
      sessionStorage.removeItem("streetTab");
      sessionStorage.removeItem("streetTemplate");
      sessionStorage.removeItem("wizardData");

      loginMessage.current = "Enter your credentials.";
      setLoginOpen(true);
    }
  }

  /**
   * Event to handle displaying the login dialog.
   */
  function HandleDisplayLogin() {
    setLoginOpen(true);
  }

  /**
   * Event to handle when the users authorisation has expired.
   */
  function HandleAuthorisationExpired() {
    navigate("/"); // Return to the home page
    HandleResetStreet();
    HandleResetProperty();
    HandleSearchDataChange("", []);
    HandleBackgroundDataChange([], [], [], []);
    HandleMapSearchDataChange([], [], [], null, null);
    HandleMapChange([], null, null);
    HandleEditMapObject(null, null);
    HandleClearInformation();
    setCurrentUser(null);
    currentUserRef.current = null;
    localStorage.removeItem("currentUser");
    loginMessage.current = "Authorisation has expired, re-enter your credentials.";
    setLoginOpen(true);
  }

  /**
   * Event to handle reloading the current user.
   */
  function HandleUserReload() {
    if (localStorage.getItem("currentUser") !== null && !currentUserRef.current) {
      const savedUser = JSON.parse(localStorage.getItem("currentUser"));
      setCurrentUser(savedUser);
      currentUserRef.current = savedUser;
    }
  }
  //endregion userContext

  //region lookupContext
  /**
   * Event to handle when the lookups change.
   *
   * @param {array} validationMessages The list of validation messages.
   * @param {array} localities The list of localities.
   * @param {array} towns The list of towns.
   * @param {array} islands The list of islands (OneScotland only)
   * @param {array} adminAuthorities The list of administrative authorities
   * @param {array} operationalDistricts The list of operational districts (GeoPlace only)
   * @param {array} appCrossRefs  The list of application cross references
   * @param {array} subLocalities The list of sub-localities (OneScotland only)
   * @param {array} streetDescriptors The list of street descriptors
   * @param {array} postTowns The list of post towns.
   * @param {array} wards The list of wards (GeoPlace only).
   * @param {array} parishes The list of parishes (GeoPlace only).
   * @param {array} dbAuthorities The list of dbAuthorities.
   */
  function HandleLookupChange(
    validationMessages,
    localities,
    towns,
    islands,
    adminAuthorities,
    operationalDistricts,
    appCrossRefs,
    subLocalities,
    postTowns,
    wards,
    parishes,
    dbAuthorities
  ) {
    setLookups({
      validationMessages: validationMessages,
      localities: localities,
      towns: towns,
      islands: islands,
      adminAuthorities: adminAuthorities,
      operationalDistricts: operationalDistricts,
      appCrossRefs: appCrossRefs,
      subLocalities: subLocalities,
      postTowns: postTowns,
      wards: wards,
      parishes: parishes,
      dbAuthorities: dbAuthorities,
    });
  }

  /**
   * Event to handle when a lookup is updated.
   *
   * @param {string} variant The type of lookup that is being updated ["validationMessage", "locality", "town", "island", "administrativeArea", "operationalDistrict", "crossReference", "subLocality", "streetDescriptor", "postTown", "postcode", "ward", "parish", "dbAuthority"]
   * @param {Array} newLookups The updated list of lookups.
   */
  function HandleUpdateLookup(variant, newLookups) {
    setLookups({
      validationMessages: variant === "validationMessage" ? newLookups : lookups.validationMessages,
      localities: variant === "locality" ? newLookups : lookups.localities,
      towns: variant === "town" ? newLookups : lookups.towns,
      islands: variant === "island" ? newLookups : lookups.islands,
      adminAuthorities: variant === "administrativeArea" ? newLookups : lookups.adminAuthorities,
      operationalDistricts: variant === "operationalDistrict" ? newLookups : lookups.operationalDistricts,
      appCrossRefs: variant === "crossReference" ? newLookups : lookups.appCrossRefs,
      subLocalities: variant === "subLocality" ? newLookups : lookups.subLocalities,
      postTowns: variant === "postTown" ? newLookups : lookups.postTowns,
      wards: variant === "ward" ? newLookups : lookups.wards,
      parishes: variant === "parish" ? newLookups : lookups.parishes,
      dbAuthorities: variant === "dbAuthority" ? newLookups : lookups.dbAuthorities,
    });
  }

  /**
   * Event to handle when the metadata version information changes.
   *
   * @param {object} apiVersion The version information from the API
   * @param {object} coreVersion The version information from the core API
   * @param {object} lookupVersion The version information from the lookup API
   * @param {object} settingsVersion The version information from the settings API
   * @param {object} iManageDbVersion The version of the iManage database.
   * @param {object} iExchangeDbVersion The version of the iExchange database.
   * @param {object} iValidateDbVersion The version of the iValidate database.
   * @param {object} iManageIndexMeta The version information for the elastic index.
   */
  function HandleMetadataChange(
    apiVersion,
    coreVersion,
    lookupVersion,
    settingsVersion,
    iManageDbVersion,
    iExchangeDbVersion,
    iValidateDbVersion,
    iManageIndexMeta
  ) {
    setMetadata({
      guiVersion: guiVersion,
      apiVersion: apiVersion ? apiVersion : "unknown",
      coreVersion: coreVersion ? coreVersion : "unknown",
      lookupVersion: lookupVersion ? lookupVersion : "unknown",
      settingsVersion: settingsVersion ? settingsVersion : "unknown",
      iManageDbVersion: iManageDbVersion ? iManageDbVersion : "unknown",
      iExchangeDbVersion: iExchangeDbVersion ? iExchangeDbVersion : "unknown",
      iValidateDbVersion: iValidateDbVersion ? iValidateDbVersion : "unknown",
      indexDBServer: iManageIndexMeta ? iManageIndexMeta.dbserver : "unknown",
      indexDBName: iManageIndexMeta ? iManageIndexMeta.dbname : "unknown",
      indexBuiltOn: iManageIndexMeta ? iManageIndexMeta.builton : "unknown",
      indexElasticVersion: iManageIndexMeta ? iManageIndexMeta.elasticnugetversion : "unknown",
    });

    sessionStorage.setItem(
      "metadata",
      JSON.stringify({
        guiVersion: guiVersion,
        apiVersion: apiVersion ? apiVersion : "unknown",
        coreVersion: coreVersion ? coreVersion : "unknown",
        lookupVersion: lookupVersion ? lookupVersion : "unknown",
        settingsVersion: settingsVersion ? settingsVersion : "unknown",
        iManageDbVersion: iManageDbVersion ? iManageDbVersion : "unknown",
        iExchangeDbVersion: iExchangeDbVersion ? iExchangeDbVersion : "unknown",
        iValidateDbVersion: iValidateDbVersion ? iValidateDbVersion : "unknown",
        indexDBServer: iManageIndexMeta ? iManageIndexMeta.dbserver : "unknown",
        indexDBName: iManageIndexMeta ? iManageIndexMeta.dbname : "unknown",
        indexBuiltOn: iManageIndexMeta ? iManageIndexMeta.builton : "unknown",
        indexElasticVersion: iManageIndexMeta ? iManageIndexMeta.elasticnugetversion : "unknown",
      })
    );
  }

  /**
   * Event to handle when an operational district record has been updated.
   *
   * @param {boolean} updated If true the operational district record has been updated.
   */
  function HandleDistrictUpdated(updated) {
    setDistrictUpdated(updated);
  }

  /**
   * Method to fetch the lookup data.
   *
   * @param {object} lookup The lookup object.
   */
  const fetchData = async (lookup) => {
    const setData = (id, result) => {
      switch (id) {
        case "lookupValidationMessages":
          setLookupValidationMessages(result);
          validationMessagesLoaded.current = true;
          break;

        case "lookupLocalities":
          setLookupLocalities(result);
          localitiesLoaded.current = true;
          break;

        case "lookupIslands":
          setLookupIslands(result);
          islandsLoaded.current = true;
          break;

        case "lookupTowns":
          setLookupTowns(result);
          townsLoaded.current = true;
          break;

        case "lookupAdminAuthorities":
          setLookupAdminAuthorities(result);
          adminAuthoritiesLoaded.current = true;
          break;

        case "lookupOperationalDistricts":
          setLookupOperationalDistricts(result);
          operationalDistrictsLoaded.current = true;
          break;

        case "lookupAppCrossRefs":
          setLookupAppCrossRefs(result);
          appCrossRefsLoaded.current = true;
          break;

        case "lookupSubLocalities":
          setLookupSubLocalities(result);
          subLocalitiesLoaded.current = true;
          break;

        case "lookupPostTowns":
          setLookupPostTowns(result);
          postTownsLoaded.current = true;
          break;

        case "lookupWards":
          setLookupWards(result);
          wardsLoaded.current = true;
          break;

        case "lookupParishes":
          setLookupParishes(result);
          parishesLoaded.current = true;
          break;

        case "lookupDbAuthorities":
          setLookupDbAuthorities(result);
          dbAuthoritiesLoaded.current = true;
          break;

        default:
          break;
      }
    };

    if (lookup.url && lookup.url.url) {
      await fetch(lookup.url.url, {
        headers: lookup.url.headers,
        crossDomain: true,
        method: "GET",
      })
        .then((response) => {
          if (response) {
            switch (response.status) {
              case 200:
                return response.json();

              case 204:
                return [];

              case 401:
                HandleAuthorisationExpired();
                setData(lookup.id, lookup.noRecords);
                break;

              case 500:
                if (userShowMessages.current)
                  console.error("[500 ERROR] Fetching data", {
                    lookup: lookup.id,
                    errorText: response.statusText,
                    response: response,
                  });
                setData(lookup.id, lookup.noRecords);
                break;

              default:
                if (userShowMessages.current)
                  console.error(`[${response.status} ERROR] Fetching data`, {
                    lookup: lookup.id,
                    errorText: response.statusText,
                    response: response,
                  });
                setData(lookup.id, lookup.noRecords);
                break;
            }
          } else return response.json();
        })
        .then((result) => {
          setData(lookup.id, result);
        })
        .catch((e) => {
          // Ignore lookups that do not exist
          if (e.message !== "Unexpected end of JSON input")
            if (userShowMessages.current)
              console.error("[ERROR] Fetching data", {
                lookup: lookup.id,
                error: e,
              });
          setData(lookup.id, lookup.noRecords);
        });
    } else {
      HandleAuthorisationExpired();
      setData(lookup.id, lookup.noRecords);
    }
  };

  /**
   * Method to load the lookups
   */
  const LoadLookups = () => {
    const Lookups = [
      {
        url: GetValidationMessagesUrl(currentUserRef.current),
        noRecords: [],
        id: "lookupValidationMessages",
      },
      {
        url: GetLocalityUrl("GET", currentUserRef.current),
        noRecords: [],
        id: "lookupLocalities",
      },
      {
        url: GetTownUrl("GET", currentUserRef.current),
        noRecords: [],
        id: "lookupTowns",
      },
      {
        url: GetIslandUrl("GET", currentUserRef.current),
        noRecords: [],
        id: "lookupIslands",
      },
      {
        url: GetAdministrativeAreaUrl("GET", currentUserRef.current),
        noRecords: [],
        id: "lookupAdminAuthorities",
      },
      {
        url: GetOperationalDistrictUrl("GET", currentUserRef.current),
        noRecords: [],
        id: "lookupOperationalDistricts",
      },
      {
        url: GetAppCrossRefUrl("GET", currentUserRef.current),
        noRecords: [],
        id: "lookupAppCrossRefs",
      },
      {
        url: GetSubLocalityUrl("GET", currentUserRef.current),
        noRecords: [],
        id: "lookupSubLocalities",
      },
      {
        url: GetPostTownUrl("GET", currentUserRef.current),
        noRecords: [],
        id: "lookupPostTowns",
      },
      {
        url: GetDbAuthorityUrl("GET", currentUserRef.current),
        noRecords: [],
        id: "lookupDbAuthorities",
      },
    ];

    Lookups.forEach((lookup) => {
      if (!loadedLookups.current.includes(lookup.id)) {
        loadedLookups.current = loadedLookups.current.concat([lookup.id]);
        fetchData(lookup);
      }
    });
  };

  /**
   * Event to handle reloading the lookup context data from storage
   */
  function HandleLookupReload() {
    if (sessionStorage.getItem("metadata") !== null && !metadata) {
      const savedMetadata = JSON.parse(sessionStorage.getItem("metadata"));
      setMetadata({
        guiVersion: savedMetadata.guiVersion,
        apiVersion: savedMetadata.apiVersion ? savedMetadata.apiVersion : "unknown",
        coreVersion: savedMetadata.coreVersion ? savedMetadata.coreVersion : "unknown",
        lookupVersion: savedMetadata.lookupVersion ? savedMetadata.lookupVersion : "unknown",
        settingsVersion: savedMetadata.settingsVersion ? savedMetadata.settingsVersion : "unknown",
        iManageDbVersion: savedMetadata.iManageDbVersion ? savedMetadata.iManageDbVersion : "unknown",
        iExchangeDbVersion: savedMetadata.iExchangeDbVersion ? savedMetadata.iExchangeDbVersion : "unknown",
        iValidateDbVersion: savedMetadata.iValidateDbVersion ? savedMetadata.iValidateDbVersion : "unknown",
        indexDBServer: savedMetadata.iManageIndexMeta ? savedMetadata.iManageIndexMeta.dbserver : "unknown",
        indexDBName: savedMetadata.iManageIndexMeta ? savedMetadata.iManageIndexMeta.dbname : "unknown",
        indexBuiltOn: savedMetadata.iManageIndexMeta ? savedMetadata.iManageIndexMeta.builton : "unknown",
        indexElasticVersion: savedMetadata.iManageIndexMeta
          ? savedMetadata.iManageIndexMeta.elasticnugetversion
          : "unknown",
      });
    }

    if (currentUserRef.current && lookups.validationMessages?.length === 0) {
      setReloadingLookups(true);
      LoadLookups();
    }
  }
  //endregion lookupContext

  //region searchContext
  /**
   * Event to handle when the search data has been changed.
   *
   * @param {string} searchString The search string that was used to perform the search.
   * @param {array} data The data that has been returned by the search.
   * @param {boolean} [reloading=false] True if this is called from the reloading method; otherwise false.
   */
  function HandleSearchDataChange(searchString, data, reloading = false) {
    const searchChanged = searchData.searchString !== searchString;
    setPreviousSearchData({
      searchString: searchData.searchString,
      results: searchData.results,
    });

    setSearchData({ searchString: searchString, results: data });
    // Need to clear out the map extent and background data when a new search is performed.
    currentMapExtent.current = null;
    if (searchChanged) {
      setMapExtent(null);
    }
    HandleBackgroundDataChange([], [], [], []);

    if (!reloading) {
      sessionStorage.setItem("searchString", searchString);
    }
  }

  /**
   * Event to handle when properties have been selected from the map.
   *
   * @param {string} action The action that needs to be done with the data.
   * @param {Array} data The data that has been returned by the search.
   */
  function HandlePropertiesSelected(action, data) {
    // Reset the various contexts
    HandleSetCoordinate(null);
    HandleEditMapObject(null, null);
    HandleStreetModified(false);
    HandleResetStreet();
    HandleResetStreetErrors();
    HandlePropertyModified(false);
    HandleResetProperty();
    HandleResetPropertyErrors();

    // Ensure we are on the gazetteer page.
    navigate("/gazetteer");

    const newMapSearchProperties = data.map((x) => {
      return {
        address: x.address,
        classificationCode: x.classification_code,
        easting: x.easting,
        formattedAddress: x.formatted_address,
        logicalStatus: x.logical_status,
        northing: x.northing,
        postcode: x.postcode,
        uprn: x.uprn.toString(),
      };
    });

    switch (action) {
      case "new":
        HandleSearchDataChange(mapSelectSearchString, data);
        HandleMapSearchDataChange(null, null, newMapSearchProperties, null, null);
        break;

      case "existing":
        const newSearchData = mergeArrays(searchData.results, data, (a, b) => a.id === b.id);
        HandleSearchDataChange(mapSelectSearchString, newSearchData);
        const newExistingMapSearchProperties = mergeArrays(
          mapSearchData.properties,
          newMapSearchProperties,
          (a, b) => Number(a.uprn) === Number(b.uprn)
        );
        HandleMapSearchDataChange(null, null, newExistingMapSearchProperties, null, null);
        break;

      default:
        break;
    }
  }

  /**
   * Event to handle the changing of the state of the search dropdown.
   *
   * @param {boolean} open True if the search dropdown is being displayed; otherwise false.
   */
  function HandleSearchOpenChange(open) {
    setSearchOpen(open);
  }

  /**
   * Event to handle when the search control needs to be hidden.
   *
   * @param {boolean} hide True if the search control should be hidden; otherwise false.
   */
  function HandleHideSearch(hide) {
    setHideSearch(hide);
  }

  /**
   * Event to handle when we need to navigate back a page.
   *
   * @param {boolean} goBack True if we need to navigate back a page; otherwise false.
   */
  function HandleNavigateBack(goBack) {
    setNavigateBack(goBack);
  }

  /**
   * Event to handle reloading the search context data from storage
   */
  function HandleSearchReload() {
    if (sessionStorage.getItem("searchString") !== null && searchData.results.length === 0) {
      const savedSearchString = sessionStorage.getItem("searchString");
      const searchUrl = GetSearchURL(currentUserRef.current);
      if (savedSearchString && savedSearchString.length > 0 && searchUrl) {
        fetch(`${searchUrl.url}/${encodeURIComponent(savedSearchString)}`, {
          headers: searchUrl.headers,
          crossDomain: true,
          method: "GET",
        }).then((response) => {
          if (response && response.status === 200) {
            response.json().then(async (data) => {
              HandleSearchDataChange(savedSearchString, data, true);
              if (
                data &&
                data.length > 0 &&
                sessionStorage.getItem("mapSearchData") !== null &&
                (!mapSearchData ||
                  (mapSearchData.streets.length === 0 &&
                    mapSearchData.llpgStreets.length === 0 &&
                    mapSearchData.properties.length === 0))
              ) {
                const searchStreetMapData = await GetSearchStreetMapData(
                  data.filter((x) => x.type === 15),
                  currentUserRef.current,
                  HandleAuthorisationExpired,
                  isScottishRef.current
                );
                const searchStreets = currentUserRef.current.hasStreet ? searchStreetMapData : [];

                const searchLlpgStreets = !currentUserRef.current.hasStreet ? searchStreetMapData : [];

                const searchProperties = data
                  .filter((x) => x.type === 24)
                  .map((x) => {
                    let propObj = {
                      uprn: x.uprn,
                      parentUprn: x.parent_uprn,
                      address: x.address,
                      formattedAddress: x.formattedaddress,
                      postcode: x.postcode,
                      easting: x.easting,
                      northing: x.northing,
                      logicalStatus: x.logical_status,
                      classificationCode: x.classification_code ? x.classification_code : "U",
                    };
                    return propObj;
                  });

                const savedMapSearchData = JSON.parse(sessionStorage.getItem("mapSearchData"));

                HandleMapSearchDataChange(
                  searchStreets,
                  searchLlpgStreets,
                  searchProperties,
                  savedMapSearchData ? savedMapSearchData.editStreet : null,
                  savedMapSearchData ? savedMapSearchData.editProperty : null,
                  true
                );
              }
            });
          }
        });
      }
    }
  }
  //endregion searchContext

  //region filterContext
  /**
   * Event to handle when the search filter data changes.
   *
   * @param {object} filterData The data used to filter the search.
   */
  function HandleSearchFilterChange(filterData) {
    setSearchFilter(filterData);
    // sessionStorage.setItem("searchFilter", JSON.stringify(filterData));
  }

  /**
   * Event to handle reloading the filter context data from storage
   */
  function HandleFilterReload() {}
  //endregion filterContext

  //region settingsContext
  /**
   * Event to handle when the settings node changes.
   *
   * @param {number} nodeId The id of the node.
   */
  function HandleNodeChange(nodeId) {
    setSettingsNode(nodeId);
    sessionStorage.setItem("settingsNode", JSON.stringify(nodeId));
  }

  /**
   * Event to handle when the authority details change.
   *
   * @param {object} details The authority details.
   * @param {boolean} [reloading=false] True if this is called from the reloading method; otherwise false.
   */
  function HandleAuthorityDetailsChange(details, reloading = false) {
    setAuthorityDetails(details);

    const formatAuthority = (authority) => {
      return StringToTitleCase(authority)
        .replace(" Of ", " of ")
        .replace(" And ", " and ")
        .replace(" The ", " the ")
        .replace(" With ", " with ");
    };

    if (details) {
      const authority = Number(details.dataProviderCode);
      setAuthorityCode(authority);
      const authorityRecord = DETRCodes.find((x) => x.id === authority);
      if (authorityRecord) setAuthorityName(formatAuthority(authorityRecord.text));
      else setAuthorityName("");
      isScottishRef.current = authority >= 9000 && authority <= 9999 && authority !== 9904;
      setIsScottish(isScottishRef.current);
      isWelshRef.current = authority >= 6000 && authority <= 6999;
      setIsWelsh(isWelshRef.current);
      if (details.tabText) {
        if (details.tabText !== document.title) document.title = details.tabText;
      } else {
        if (authorityRecord) document.title = `iManage GMS (${formatAuthority(authorityRecord.text)})`;
        else document.title = "iManage GMS";
      }
    } else {
      setAuthorityCode(0);
      setAuthorityName("");
      isScottishRef.current = false;
      setIsScottish(isScottishRef.current);
      isWelshRef.current = false;
      setIsWelsh(isWelshRef.current);
      document.title = "iManage GMS";
    }

    if (!reloading) {
      sessionStorage.setItem("authorityDetails", JSON.stringify(details));
    }
  }

  /**
   * Event to handle when the array of property templates change.
   *
   * @param {array} templates Array of property templates.
   * @param {boolean} [reloading=false] True if this is called from the reloading method; otherwise false.
   */
  function HandlePropertyTemplatesChange(templates, reloading = false) {
    setPropertyTemplates(templates);
    if (!reloading) {
      sessionStorage.setItem("propertyTemplates", JSON.stringify(templates));
    }
  }

  /**
   * Event to handle when the street template changes.
   *
   * @param {object} template The street template.
   * @param {boolean} [reloading=false] True if this is called from the reloading method; otherwise false.
   */
  function HandleStreetTemplateChange(template, reloading = false) {
    setStreetTemplate(template);
    if (!reloading) {
      sessionStorage.setItem("streetTemplate", JSON.stringify(template));
    }
  }

  /**
   * Event to handle when the array of map layers have changed.
   *
   * @param {array} data The list of map layers to be used by the application.
   * @param {boolean} [reloading=false] True if this is called from the reloading method; otherwise false.
   */
  function HandleMapLayersChange(data, reloading = false) {
    setMapLayers(data);
    if (!reloading) {
      sessionStorage.setItem("mapLayers", JSON.stringify(data));
    }
  }

  /**
   * Event to handle when the metadata language changes.
   *
   * @param {string} streetLanguage The language for the street.
   * @param {string} asdLanguage The language for the ASD.
   * @param {string} propertyLanguage The language for the property.
   */
  function HandleMetadataLanguagesChanged(streetLanguage, asdLanguage, propertyLanguage) {
    setMetadataLanguages({
      street: streetLanguage,
      asd: asdLanguage,
      property: propertyLanguage,
    });
  }

  /**
   * Event to handle reloading the settings context data from storage
   */
  function HandleSettingsReload() {
    if (sessionStorage.getItem("settingsNode") !== null) {
      setSettingsNode(JSON.parse(sessionStorage.getItem("settingsNode")));
    }
    if (sessionStorage.getItem("authorityDetails") !== null && !authorityDetails.dataProviderCode) {
      HandleAuthorityDetailsChange(JSON.parse(sessionStorage.getItem("authorityDetails")), true);
    }
    if (
      sessionStorage.getItem("propertyTemplates") !== null &&
      (!propertyTemplates || propertyTemplates.length === 0)
    ) {
      HandlePropertyTemplatesChange(JSON.parse(sessionStorage.getItem("propertyTemplates")), true);
    }
    if (sessionStorage.getItem("streetTemplate") !== null && (!streetTemplate || streetTemplate.length === 0)) {
      HandleStreetTemplateChange(JSON.parse(sessionStorage.getItem("streetTemplate")), true);
    }
    if (sessionStorage.getItem("mapLayers") !== null && (!mapLayers || mapLayers.length === 0)) {
      HandleMapLayersChange(JSON.parse(sessionStorage.getItem("mapLayers")), true);
    }
  }
  //endregion settingsContext

  //region streetContext
  /**
   * Event to handle when the current street data has changed.
   *
   * @param {number} usrn The USRN of the street.
   * @param {string} descriptor The descriptor for the street.
   * @param {boolean} newStreet True if this is a new street; otherwise false.
   * @param {number|null} [openRelated=null] If present it contains the USRN of the street that we need the the related tab opened.
   */
  function HandleStreetChange(usrn, descriptor, newStreet, openRelated = null) {
    setStreet({
      usrn: usrn,
      descriptor: descriptor,
      newStreet: newStreet,
      openRelated: openRelated ? openRelated : street.openRelated,
    });

    sessionStorage.setItem(
      "street",
      JSON.stringify({
        usrn: usrn,
        descriptor: descriptor,
        newStreet: newStreet,
        openRelated: openRelated ? openRelated : street.openRelated,
      })
    );

    if (usrn && usrn > 0) navigate(`/street/${usrn}`);
    else if (newStreet) {
      setCreatingStreet(true);
      navigate("/street/-1");
    }
  }

  /**
   * Event to handle when the current street data has been updated.
   *
   * @param {number} usrn The USRN of the street.
   * @param {string} descriptor The descriptor for the street.
   * @param {boolean} newStreet True if this is a new street; otherwise false.
   * @param {number|null} [openRelated=null] If present it contains the USRN of the street that we need the the related tab opened.
   */
  function HandleUpdateCurrentStreet(usrn, descriptor, newStreet, openRelated = null) {
    setStreet({
      usrn: usrn,
      descriptor: descriptor,
      newStreet: newStreet,
      openRelated: openRelated ? openRelated : street.openRelated,
    });

    sessionStorage.setItem(
      "street",
      JSON.stringify({
        usrn: usrn,
        descriptor: descriptor,
        newStreet: newStreet,
        openRelated: openRelated ? openRelated : street.openRelated,
      })
    );
  }

  /**
   * Method to clear the street creating flag.
   */
  function HandleStreetCreated() {
    setCreatingStreet(false);
  }

  /**
   * Event to handle when the street is closed.
   *
   * @param {boolean} closing True if the current street is being closed; otherwise false.
   */
  function HandleCloseStreet(closing) {
    setStreetClosing(closing);
  }

  /**
   * Event to handle setting the modified flag for the current street.
   *
   * @param {boolean} changed True if the current street has been modified; otherwise false.
   */
  function HandleStreetModified(changed) {
    setStreetModified(changed);
    if (!changed) setEsuDividedMerged(changed);
  }

  /**
   * Event to handle when the street errors change.
   *
   * @param {array|null} streetErrors The list of street errors.
   * @param {array|null} descriptorErrors The list of descriptor errors.
   * @param {array|null} esuErrors The list of ESU errors.
   * @param {array|null} successorCrossRefErrors The list of successor cross reference errors (OneScotland only).
   * @param {array|null} highwayDedicationErrors The list of highway dedication errors (GeoPlace only).
   * @param {array|null} oneWayExemptionErrors The list of one-way exemption errors (GeoPlace only).
   * @param {array|null} maintenanceResponsibilityErrors The list of maintenance responsibility errors (OneScotland only).
   * @param {array|null} reinstatementCategoryErrors The list of reinstatement category errors (OneScotland only).
   * @param {array|null} osSpecialDesignationErrors The list of special designation errors (OneScotland only).
   * @param {array|null} interestErrors The list of interest errors (GeoPlace only).
   * @param {array|null} constructionErrors The list of construction errors (GeoPlace only).
   * @param {array|null} specialDesignationErrors The list of special designation errors (GeoPlace only).
   * @param {array|null} heightWidthWeightErrors The list of height, width & weight errors (GeoPlace only).
   * @param {array|null} publicRightOfWayErrors The list of public rights of way errors (GeoPlace only).
   * @param {array|null} noteErrors The list of note errors.
   * @param {boolean} [reloading=false] True if this is called from the reloading method; otherwise false.
   */
  function HandleStreetErrors(
    streetErrors,
    descriptorErrors,
    esuErrors,
    successorCrossRefErrors,
    highwayDedicationErrors,
    oneWayExemptionErrors,
    maintenanceResponsibilityErrors,
    reinstatementCategoryErrors,
    osSpecialDesignationErrors,
    interestErrors,
    constructionErrors,
    specialDesignationErrors,
    heightWidthWeightErrors,
    publicRightOfWayErrors,
    noteErrors,
    reloading = false
  ) {
    setStreetErrors({
      street: streetErrors && streetErrors.length > 0 ? streetErrors : [],
      descriptor: descriptorErrors && descriptorErrors.length > 0 ? descriptorErrors : [],
      esu: esuErrors && esuErrors.length > 0 ? esuErrors : [],
      highwayDedication: highwayDedicationErrors && highwayDedicationErrors.length > 0 ? highwayDedicationErrors : [],
      oneWayExemption: oneWayExemptionErrors && oneWayExemptionErrors.length > 0 ? oneWayExemptionErrors : [],
      successorCrossRef: successorCrossRefErrors && successorCrossRefErrors.length > 0 ? successorCrossRefErrors : [],
      maintenanceResponsibility:
        maintenanceResponsibilityErrors && maintenanceResponsibilityErrors.length > 0
          ? maintenanceResponsibilityErrors
          : [],
      reinstatementCategory:
        reinstatementCategoryErrors && reinstatementCategoryErrors.length > 0 ? reinstatementCategoryErrors : [],
      osSpecialDesignation:
        osSpecialDesignationErrors && osSpecialDesignationErrors.length > 0 ? osSpecialDesignationErrors : [],
      interest: interestErrors && interestErrors.length > 0 ? interestErrors : [],
      construction: constructionErrors && constructionErrors.length > 0 ? constructionErrors : [],
      specialDesignation:
        specialDesignationErrors && specialDesignationErrors.length > 0 ? specialDesignationErrors : [],
      heightWidthWeight: heightWidthWeightErrors && heightWidthWeightErrors.length > 0 ? heightWidthWeightErrors : [],
      publicRightOfWay: publicRightOfWayErrors && publicRightOfWayErrors.length > 0 ? publicRightOfWayErrors : [],
      note: noteErrors && noteErrors.length > 0 ? noteErrors : [],
    });
    setStreetHasErrors(
      (streetErrors && streetErrors.length > 0) ||
        (descriptorErrors && descriptorErrors.length > 0) ||
        (esuErrors && esuErrors.length > 0) ||
        (highwayDedicationErrors && highwayDedicationErrors.length > 0) ||
        (oneWayExemptionErrors && oneWayExemptionErrors.length > 0) ||
        (successorCrossRefErrors && successorCrossRefErrors.length > 0) ||
        (maintenanceResponsibilityErrors && maintenanceResponsibilityErrors.length > 0) ||
        (reinstatementCategoryErrors && reinstatementCategoryErrors.length > 0) ||
        (osSpecialDesignationErrors && osSpecialDesignationErrors.length > 0) ||
        (interestErrors && interestErrors.length > 0) ||
        (constructionErrors && constructionErrors.length > 0) ||
        (specialDesignationErrors && specialDesignationErrors.length > 0) ||
        (heightWidthWeightErrors && heightWidthWeightErrors.length > 0) ||
        (publicRightOfWayErrors && publicRightOfWayErrors.length > 0) ||
        (noteErrors && noteErrors.length > 0)
    );

    if (!reloading) {
      sessionStorage.setItem(
        "streetErrors",
        JSON.stringify({
          street: streetErrors && streetErrors.length > 0 ? streetErrors : [],
          descriptor: descriptorErrors && descriptorErrors.length > 0 ? descriptorErrors : [],
          esu: esuErrors && esuErrors.length > 0 ? esuErrors : [],
          highwayDedication:
            highwayDedicationErrors && highwayDedicationErrors.length > 0 ? highwayDedicationErrors : [],
          oneWayExemption: oneWayExemptionErrors && oneWayExemptionErrors.length > 0 ? oneWayExemptionErrors : [],
          successorCrossRef:
            successorCrossRefErrors && successorCrossRefErrors.length > 0 ? successorCrossRefErrors : [],
          maintenanceResponsibility:
            maintenanceResponsibilityErrors && maintenanceResponsibilityErrors.length > 0
              ? maintenanceResponsibilityErrors
              : [],
          reinstatementCategory:
            reinstatementCategoryErrors && reinstatementCategoryErrors.length > 0 ? reinstatementCategoryErrors : [],
          osSpecialDesignation:
            osSpecialDesignationErrors && osSpecialDesignationErrors.length > 0 ? osSpecialDesignationErrors : [],
          interest: interestErrors && interestErrors.length > 0 ? interestErrors : [],
          construction: constructionErrors && constructionErrors.length > 0 ? constructionErrors : [],
          specialDesignation:
            specialDesignationErrors && specialDesignationErrors.length > 0 ? specialDesignationErrors : [],
          heightWidthWeight:
            heightWidthWeightErrors && heightWidthWeightErrors.length > 0 ? heightWidthWeightErrors : [],
          publicRightOfWay: publicRightOfWayErrors && publicRightOfWayErrors.length > 0 ? publicRightOfWayErrors : [],
          note: noteErrors && noteErrors.length > 0 ? noteErrors : [],
        })
      );
    }
  }

  /**
   * Method used to handle when we are leaving the current street to go to a new street or property.
   *
   * @param {string|null} why The reason why we are leaving the current street.
   * @param {object|null} information The information required to use when leaving the street.
   */
  function HandleLeavingStreet(why, information) {
    if (why) setLeavingStreet({ why: why, information: information });
    else setLeavingStreet(null);
  }

  /**
   * Goes to a specific field on a specific record for a street record.
   *
   * @param {number} type The record type where the field is located
   * @param {number} index The index of the record within the array of records.
   * @param {number|null} parentIndex The index of the ESU record when going to a highway dedication or one-way exemption record.
   * @param {string} fieldName The index of the record within the array of records.
   */
  function HandleStreetGoToField(type, index, parentIndex, fieldName) {
    if (type === null) setStreetGoToField(null);
    else
      setStreetGoToField({
        type: type,
        index: index,
        parentIndex: parentIndex,
        fieldName: fieldName,
      });
  }

  /**
   * Event to handle when the street record changes.
   *
   * @param {number} type The type of street record.
   * @param {number} id The id of the record.
   * @param {number} index The index of the street record in the search array.
   * @param {number} parentIndex The index for the parent
   * @param {boolean} [newRecord=false] True if this is a new record; otherwise false.
   */
  function HandleStreetRecordChange(type, id, index, parentIndex, newRecord = false) {
    setStreetRecord({ type: type, id: id, index: index, parentIndex: parentIndex, newRecord: newRecord });
    if (type === 13) {
      if (!id) {
        setEsuChecked([]);
      } else {
        setRefreshEsuGeometry(false);
      }
    }

    sessionStorage.setItem(
      "streetRecord",
      JSON.stringify({ type: type, id: id, index: index, parentIndex: parentIndex, newRecord: newRecord })
    );
  }

  /**
   * Event to handle when the ESU data has been changed.
   *
   * @param {boolean} changed True if the ESU data has changed; otherwise false.
   */
  function HandleEsuDataChange(changed) {
    setEsuDataChanged(changed);
  }

  /**
   * Event to handle resetting the street.
   */
  function HandleResetStreet() {
    previousStreet.current = street;
    HandleStreetChange(0, "", false);
    setExpandedEsu([]);
    setExpandedAsd([]);
  }

  /**
   * Event to handle restoring the street state object.
   */
  function HandleRestoreStreet() {
    if (previousStreet.current?.usrn > 0)
      //IMANN-1792 set street if previousStreet is not empty
      setStreet(previousStreet.current);
    if (previousStreetMapSearchData.current) {
      setMapSearchData(previousStreetMapSearchData.current);
    }
    setStreetRestored(true);
  }

  /**
   * Event to handle storing the current street state object.
   */
  function HandleStoreCurrentStreet() {
    previousStreet.current = street;
    previousStreetMapSearchData.current = mapSearchData;
    setStreetRestored(false);
  }

  /**
   * Event to handle when the street is opened at the related tab.
   */
  function HandleStreetRelatedOpened() {
    setStreet({
      usrn: street.usrn,
      descriptor: street.descriptor,
      newStreet: street.newStreet,
      openRelated: null,
    });
  }

  /**
   * Event to handle when the list of Esus that are checked are changed
   *
   * @param {array} esuChecked
   */
  function HandleEsuCheckedChanged(esuChecked) {
    setEsuChecked(esuChecked);
  }

  /**
   * Event to handle when an ESU is selected in the map.
   *
   * @param {number|null} esuId The ESU id for the ESU that has been selected.
   */
  function HandleEsuSelected(esuId) {
    setSelectedMapEsuId(esuId);
    sessionStorage.setItem("esu", esuId);
  }

  /**
   * Event to handle when 2 ESUs are merged together.
   *
   * @param {number|null} esuId1 The ESU id for the first ESU that has been merged.
   * @param {number|null} esuId2 The ESU id for the second ESU that has been merged.
   * @param {Array|null} newGeometry The array of points making up the new geometry for the merged ESUs.
   */
  function HandleMergedEsus(esuId1, esuId2, newGeometry) {
    if (!esuId1) setMergedEsus(null);
    else setMergedEsus({ esuId1: esuId1, esuId2: esuId2, newGeometry: newGeometry });
  }

  /**
   * Event to handle when ESUs are unassigned from a street.
   *
   * @param {Array|null} esus The list of ESU Ids to be unassigned from the street.
   */
  function HandleUnassignEsus(esus) {
    if (!esus) setUnassignEsus(null);
    else setUnassignEsus(esus);
  }

  /**
   * Event to handle when an ESU is assigned to a street.
   *
   * @param {number|null} esuId The Id of the ESU that needs to be assigned to the street.
   */
  function HandleAssignEsu(esuId) {
    setAssignEsu(esuId);
  }

  /**
   * Event to handle when ESUs are assigned to a street.
   *
   * @param {Array|null} esus The list of ESU Ids to be assigned to the street.
   */
  function HandleAssignEsus(esus) {
    if (!esus) setAssignEsus(null);
    else setAssignEsus(esus);
    HandlePointCapture(null);
  }

  /**
   * Event to handle when ESUs are used to create a street.
   *
   * @param {Array|null} esus The list of ESU Ids to be used to create the street.
   */
  function HandleCreateStreetFromEsus(esus) {
    if (!esus) setCreateEsus(null);
    else {
      setCreateEsus(esus);
      HandleStreetChange(0, "New Street", true);
    }
    HandlePointCapture(null);
  }

  /**
   * Event to handle when an ESU has been divided or merged.
   *
   * @param {boolean} hasBeenDividedMerged True if an ESU has been divided or merged.
   */
  function HandleEsuDividedMerged(hasBeenDividedMerged) {
    setEsuDividedMerged(hasBeenDividedMerged);
  }

  /**
   * Event to handle when an ESU is expanded or collapsed.
   *
   * @param {string} title The title of the item we are expanding or collapsing.
   */
  function HandleToggleEsuExpanded(title) {
    const newList = [...expandedEsu];
    const index = newList.indexOf(title);
    if (index > -1) newList.splice(index, 1);
    else newList.push(title);

    setExpandedEsu(newList);
    sessionStorage.setItem("expandedEsu", JSON.stringify(newList));
  }

  /**
   * Event to handle when an ASD is expanded or collapsed.
   *
   * @param {string} title The title of the item we are expanding or collapsing.
   */
  function HandleToggleAsdExpanded(title) {
    const newList = [...expandedAsd];
    const index = newList.indexOf(title);
    if (index > -1) newList.splice(index, 1);
    else newList.push(title);

    setExpandedAsd(newList);
    sessionStorage.setItem("expandedAsd", JSON.stringify(newList));
  }

  /**
   * Event to handle resetting the street errors.
   */
  function HandleResetStreetErrors() {
    HandleStreetErrors([], [], [], [], [], [], [], [], [], [], [], [], [], [], []);
  }

  /**
   * Event to handle validating the street data.
   *
   * @returns {boolean} True if the street is valid; otherwise false.
   */
  function HandleStreetValidateData() {
    let isValid = true;

    const updateStreetErrors = (newErrors, type) => {
      HandleStreetErrors(
        type === "street" ? newErrors : streetErrors.street,
        type === "descriptor" ? newErrors : streetErrors.descriptor,
        type === "esu" ? newErrors : streetErrors.esu,
        type === "successorCrossRef" ? newErrors : streetErrors.successorCrossRef,
        type === "highwayDedication" ? newErrors : streetErrors.highwayDedication,
        type === "oneWayExemption" ? newErrors : streetErrors.oneWayExemption,
        type === "maintenanceResponsibility" ? newErrors : streetErrors.maintenanceResponsibility,
        type === "reinstatementCategory" ? newErrors : streetErrors.reinstatementCategory,
        type === "osSpecialDesignation" ? newErrors : streetErrors.osSpecialDesignation,
        type === "interest" ? newErrors : streetErrors.interest,
        type === "construction" ? newErrors : streetErrors.construction,
        type === "specialDesignation" ? newErrors : streetErrors.specialDesignation,
        type === "heightWidthWeight" ? newErrors : streetErrors.heightWidthWeight,
        type === "publicRightOfWay" ? newErrors : streetErrors.publicRightOfWay,
        type === "note" ? newErrors : streetErrors.note
      );
    };

    if (streetModified) {
      switch (streetRecord.type) {
        case 11:
          if (currentStreet) {
            const streetData = {
              usrn: currentStreet.usrn,
              swaOrgRefNaming: currentStreet.swaOrgRefNaming,
              streetSurface: currentStreet.streetSurface,
              streetStartDate: currentStreet.streetStartDate,
              streetEndDate: currentStreet.streetEndDate,
              streetStartX: currentStreet.streetStartX,
              streetStartY: currentStreet.streetStartY,
              streetEndX: currentStreet.streetEndX,
              streetEndY: currentStreet.streetEndY,
              manuallySetStartEnd: currentStreet.manuallySetStartEnd,
              neverExport: currentStreet.neverExport,
              recordType: currentStreet.recordType,
              state: currentStreet.state,
              stateDate: currentStreet.stateDate,
              streetClassification: currentStreet.streetClassification,
              streetTolerance: currentStreet.streetTolerance,
              esus: currentStreet.esus,
              successorCrossRefs: currentStreet.successorCrossRefs,
            };
            const errorStreet = ValidateStreetData(streetData, lookups, isScottishRef.current, authorityCode);
            isValid = errorStreet.length === 0;
            updateStreetErrors(errorStreet, "street");
          }
          break;

        case 13:
          if (currentEsuRecord) {
            const esuErrors = ValidateEsuData(currentEsuRecord, streetRecord.index, lookups, isScottishRef.current);
            isValid = esuErrors.length === 0;
            updateStreetErrors(esuErrors, "esu");
          }
          break;

        case 15:
          if (currentDescriptorRecord) {
            const descriptorErrors = ValidateDescriptorData(
              currentDescriptorRecord,
              streetRecord.index,
              lookups,
              isScottishRef.current,
              isWelshRef.current
            );
            isValid = descriptorErrors.length === 0;
            updateStreetErrors(descriptorErrors, "descriptor");
          }
          break;

        case 16:
          if (currentOneWayExemptionRecord) {
            const oneWayExemptionErrors = ValidateOneWayExemptionData(
              currentOneWayExemptionRecord,
              streetRecord.index,
              streetRecord.parentIndex,
              lookups,
              isScottishRef.current
            );
            isValid = oneWayExemptionErrors.length === 0;
            updateStreetErrors(oneWayExemptionErrors, "oneWayExemption");
          }
          break;

        case 17:
          if (currentHighwayDedicationRecord) {
            const highwayDedicationErrors = ValidateHighwayDedicationData(
              currentHighwayDedicationRecord,
              streetRecord.index,
              streetRecord.parentIndex,
              lookups,
              isScottishRef.current
            );
            isValid = highwayDedicationErrors.length === 0;
            updateStreetErrors(highwayDedicationErrors, "highwayDedication");
          }
          break;

        case 51:
          if (currentMaintenanceResponsibilityRecord) {
            const maintenanceResponsibilityErrors = ValidateMaintenanceResponsibilityData(
              currentMaintenanceResponsibilityRecord,
              streetRecord.index,
              lookups
            );
            isValid = maintenanceResponsibilityErrors.length === 0;
            updateStreetErrors(maintenanceResponsibilityErrors, "maintenanceResponsibility");
          }
          break;

        case 52:
          if (currentReinstatementCategoryRecord) {
            const reinstatementCategoryErrors = ValidateReinstatementCategoryData(
              currentReinstatementCategoryRecord,
              streetRecord.index,
              lookups
            );
            isValid = reinstatementCategoryErrors.length === 0;
            updateStreetErrors(reinstatementCategoryErrors, "reinstatementCategory");
          }
          break;

        case 53:
          if (currentOSSpecialDesignationRecord) {
            const osSpecialDesignationErrors = ValidateOSSpecialDesignationData(
              currentOSSpecialDesignationRecord,
              streetRecord.index,
              lookups
            );
            isValid = osSpecialDesignationErrors.length === 0;
            updateStreetErrors(osSpecialDesignationErrors, "osSpecialDesignation");
          }
          break;

        case 61:
          if (currentInterestRecord) {
            const interestErrors = ValidateInterestData(
              currentInterestRecord,
              streetRecord.index,
              lookups,
              authorityCode
            );
            isValid = interestErrors.length === 0;
            updateStreetErrors(interestErrors, "interest");
          }
          break;

        case 62:
          if (currentConstructionRecord) {
            const constructionErrors = ValidateConstructionData(
              currentConstructionRecord,
              streetRecord.index,
              lookups,
              authorityCode
            );
            isValid = constructionErrors.length === 0;
            updateStreetErrors(constructionErrors, "construction");
          }
          break;

        case 63:
          if (currentSpecialDesignationRecord) {
            const specialDesignationErrors = ValidateSpecialDesignationData(
              currentSpecialDesignationRecord,
              streetRecord.index,
              lookups,
              authorityCode
            );
            isValid = specialDesignationErrors.length === 0;
            updateStreetErrors(specialDesignationErrors, "specialDesignation");
          }
          break;

        case 64:
          if (currentHWWRecord) {
            const heightWidthWeightErrors = ValidateHeightWidthWeightData(
              currentHWWRecord,
              streetRecord.index,
              lookups,
              authorityCode
            );
            isValid = heightWidthWeightErrors.length === 0;
            updateStreetErrors(heightWidthWeightErrors, "heightWidthWeight");
          }
          break;

        case 66:
          if (currentPRoWRecord) {
            const publicRightOfWayErrors = ValidatePublicRightOfWayData(currentPRoWRecord, streetRecord.index, lookups);
            isValid = publicRightOfWayErrors.length === 0;
            updateStreetErrors(publicRightOfWayErrors, "publicRightOfWay");
          }
          break;

        case 72:
          if (currentStreetNoteRecord) {
            const noteErrors = ValidateStreetNoteData(
              currentStreetNoteRecord,
              streetRecord.index,
              lookups,
              isScottishRef.current
            );
            isValid = noteErrors.length === 0;
            updateStreetErrors(noteErrors, "note");
          }
          break;

        default:
          break;
      }
    }

    return isValid;
  }

  /**
   * Event to handle reloading the street context data from storage
   */
  function HandleStreetReload() {
    if (sessionStorage.getItem("street") !== null && street.descriptor === "!+reload+!") {
      const savedStreet = JSON.parse(sessionStorage.getItem("street"));
      setStreet({
        usrn: savedStreet.usrn,
        descriptor: savedStreet.descriptor,
        newStreet: savedStreet.newStreet,
        openRelated: savedStreet.openRelated ? savedStreet.openRelated : street.openRelated,
      });
    }
    if (
      sessionStorage.getItem("streetErrors") !== null &&
      streetErrors.street.length === 0 &&
      streetErrors.descriptor.length === 0 &&
      streetErrors.esu.length === 0 &&
      streetErrors.highwayDedication.length === 0 &&
      streetErrors.oneWayExemption.length === 0 &&
      streetErrors.successorCrossRef.length === 0 &&
      streetErrors.interest.length === 0 &&
      streetErrors.maintenanceResponsibility.length === 0 &&
      streetErrors.reinstatementCategory.length === 0 &&
      streetErrors.osSpecialDesignation.length === 0 &&
      streetErrors.construction.length === 0 &&
      streetErrors.specialDesignation.length === 0 &&
      streetErrors.heightWidthWeight.length === 0 &&
      streetErrors.publicRightOfWay.length === 0 &&
      streetErrors.note.length
    ) {
      const savedStreetErrors = JSON.parse(sessionStorage.getItem("streetErrors"));
      HandleStreetErrors(
        savedStreetErrors.streetErrors,
        savedStreetErrors.descriptorErrors,
        savedStreetErrors.esuErrors,
        savedStreetErrors.successorCrossRefErrors,
        savedStreetErrors.highwayDedicationErrors,
        savedStreetErrors.oneWayExemptionErrors,
        savedStreetErrors.maintenanceResponsibilityErrors,
        savedStreetErrors.reinstatementCategoryErrors,
        savedStreetErrors.osSpecialDesignationErrors,
        savedStreetErrors.interestErrors,
        savedStreetErrors.constructionErrors,
        savedStreetErrors.specialDesignationErrors,
        savedStreetErrors.heightWidthWeightErrors,
        savedStreetErrors.publicRightOfWayErrors,
        savedStreetErrors.noteErrors,
        true
      );
    }
    if (
      sessionStorage.getItem("streetRecord") !== null &&
      streetRecord.type === 11 &&
      !streetRecord.id &&
      !streetRecord.index
    ) {
      const savedStreetRecord = JSON.parse(sessionStorage.getItem("streetRecord"));
      setStreetRecord({
        type: savedStreetRecord.type,
        id: savedStreetRecord.id,
        index: savedStreetRecord.index,
        parentIndex: savedStreetRecord.parentIndex,
        newRecord: savedStreetRecord.newRecord,
      });
    }
    if (sessionStorage.getItem("esu") !== null && !selectedMapEsuId) {
      setSelectedMapEsuId(Number(sessionStorage.getItem("esu")));
    }
    if (sessionStorage.getItem("expandedEsu") !== null && expandedEsu.length === 0) {
      setExpandedEsu(JSON.parse(sessionStorage.getItem("expandedEsu")));
    }
    if (sessionStorage.getItem("expandedAsd") !== null && expandedAsd.length === 0) {
      setExpandedAsd(JSON.parse(sessionStorage.getItem("expandedAsd")));
    }
  }
  //endregion streetContext

  //region propertyContext
  /**
   * Event to handle the changing of a property.
   *
   * @param {Number} uprn The UPRN of the property.
   * @param {Number} usrn The USRN of the street the property is on.
   * @param {String} address The address of the property.
   * @param {String} formattedAddress The formatted address for the property.
   * @param {String} postcode The postcode for the address.
   * @param {Number} easting The easting of the property.
   * @param {Number} northing The northing of the property.
   * @param {Boolean} newProperty True if this is a new property; otherwise false.
   * @param {Object|null} parent The parent object for the property.
   * @param {Object|null} [openRelated=null] If present it contains the UPRN of the property that we need the the related tab opened.
   * @param {Boolean} [reloading=false] True if this is called from the reloading method; otherwise false.
   */
  async function HandlePropertyChange(
    uprn,
    usrn,
    address,
    formattedAddress,
    postcode,
    easting,
    northing,
    newProperty,
    parent,
    openRelated = null,
    reloading = false
  ) {
    async function GetParentUprn(uprn) {
      const propertyUrl = GetPropertyFromUPRNUrl(openRelated.currentUser);

      if (propertyUrl) {
        const parentUprn = await fetch(`${propertyUrl.url}/${uprn}`, {
          headers: propertyUrl.headers,
          crossDomain: true,
          method: "GET",
        })
          .then((res) => (res.ok ? res : Promise.reject(res)))
          .then((res) => {
            if (res.status === 401) {
              HandleAuthorisationExpired();
              return null;
            } else {
              return res.json();
            }
          })
          .then(
            (result) => {
              return result.parentUprn;
            },
            (error) => {
              if (userShowMessages.current) console.error("[ERROR] Get Property data", error);
              return null;
            }
          );

        return parentUprn;
      } else return null;
    }

    let relatedProperty = null;

    if (openRelated) {
      let expandList = [`${openRelated.property.toString()}`];
      let topNodeId = `property-related-tree-${openRelated.property.toString()}`;

      if (openRelated.parent) {
        expandList.push(openRelated.parent.toString());
        topNodeId = `property-related-tree-${openRelated.parent.toString()}`;
        const grandParent = await GetParentUprn(openRelated.parent);

        if (grandParent) {
          expandList.push(grandParent.toString());
          topNodeId = `property-related-tree-${grandParent.toString()}`;
          const greatGrandParent = await GetParentUprn(grandParent);

          if (greatGrandParent) {
            expandList.push(greatGrandParent.toString());
            topNodeId = `property-related-tree-${greatGrandParent.toString()}`;
          }
        }
      }

      relatedProperty = {
        property: openRelated.property,
        expandList: expandList,
        topNodeId: topNodeId,
      };
    }

    setProperty({
      uprn: uprn,
      usrn: usrn,
      address: address,
      formattedAddress: formattedAddress,
      postcode: postcode,
      easting: easting,
      northing: northing,
      newProperty: newProperty,
      parent: parent,
      openRelated: openRelated ? relatedProperty : property.openRelated,
    });

    if (!reloading) {
      sessionStorage.setItem(
        "property",
        JSON.stringify({
          uprn: uprn,
          usrn: usrn,
          address: address,
          formattedAddress: formattedAddress,
          postcode: postcode,
          easting: easting,
          northing: northing,
          newProperty: newProperty,
          parent: parent,
          openRelated: openRelated ? relatedProperty : property.openRelated,
        })
      );
    }

    if (uprn && Number(uprn) > 0) navigate(`/property/${uprn}`);
    else if (newProperty) navigate("/property/0");
  }

  /**
   * Event to handle the changing of a property.
   *
   * @param {Number} uprn The UPRN of the property.
   * @param {Number} usrn The USRN of the street the property is on.
   * @param {String} address The address of the property.
   * @param {String} formattedAddress The formatted address for the property.
   * @param {String} postcode The postcode for the address.
   * @param {Number} easting The easting of the property.
   * @param {Number} northing The northing of the property.
   * @param {Boolean} newProperty True if this is a new property; otherwise false.
   * @param {Object|null} parent The parent object for the property.
   */
  function HandleUpdateCurrentProperty(
    uprn,
    usrn,
    address,
    formattedAddress,
    postcode,
    easting,
    northing,
    newProperty,
    parent
  ) {
    setProperty({
      uprn: uprn,
      usrn: usrn,
      address: address,
      formattedAddress: formattedAddress,
      postcode: postcode,
      easting: easting,
      northing: northing,
      newProperty: newProperty,
      parent: parent,
      openRelated: property.openRelated,
    });

    sessionStorage.setItem(
      "property",
      JSON.stringify({
        uprn: uprn,
        usrn: usrn,
        address: address,
        formattedAddress: formattedAddress,
        postcode: postcode,
        easting: easting,
        northing: northing,
        newProperty: newProperty,
        parent: parent,
        openRelated: property.openRelated,
      })
    );
  }

  /**
   * Event to handle the change of logical status of the property.
   *
   * @param {number} logicalStatus The logical status of the property.
   */
  function HandleLogicalStatusChange(logicalStatus) {
    setLogicalStatus(logicalStatus);
  }

  /**
   * Event to handle setting a flag to determine if the current property has been modified.
   *
   * @param {boolean} changed True if the property has been modified; otherwise false.
   */
  function HandlePropertyModified(changed) {
    setPropertyModified(changed);
  }

  /**
   * Event to handle the property errors.
   *
   * @param {array|null} blpuErrors The list of BLPU errors.
   * @param {array|null} lpiErrors The list of LPI errors.
   * @param {array|null} provenanceErrors The list of provenance errors.
   * @param {array|null} crossRefErrors The list of cross reference errors.
   * @param {array|null} classificationErrors The list of classification errors (OneScotland only).
   * @param {array|null} organisationErrors The list of organisation errors (OneScotland only).
   * @param {array|null} successorCrossRefErrors The list of successor cross reference errors (OneScotland only).
   * @param {array|null} noteErrors The list of note errors.
   * @param {number} pkId The id of the current property.
   * @param {boolean} [reloading=false] True if this is called from the reloading method; otherwise false.
   */
  function HandlePropertyErrors(
    blpuErrors,
    lpiErrors,
    provenanceErrors,
    crossRefErrors,
    classificationErrors,
    organisationErrors,
    successorCrossRefErrors,
    noteErrors,
    pkId,
    reloading = false
  ) {
    const newErrors = {
      pkId: pkId,
      blpu: blpuErrors && blpuErrors.length > 0 ? blpuErrors : [],
      lpi: lpiErrors && lpiErrors.length > 0 ? lpiErrors : [],
      provenance: provenanceErrors && provenanceErrors.length > 0 ? provenanceErrors : [],
      crossRef: crossRefErrors && crossRefErrors.length > 0 ? crossRefErrors : [],
      classification: classificationErrors && classificationErrors.length > 0 ? classificationErrors : [],
      organisation: organisationErrors && organisationErrors.length > 0 ? organisationErrors : [],
      successorCrossRef: successorCrossRefErrors && successorCrossRefErrors.length > 0 ? successorCrossRefErrors : [],
      note: noteErrors && noteErrors.length > 0 ? noteErrors : [],
    };
    setPropertyErrors(newErrors);

    const newHasErrors =
      blpuErrors?.length > 0 ||
      lpiErrors?.length > 0 ||
      provenanceErrors?.length > 0 ||
      crossRefErrors?.length > 0 ||
      classificationErrors?.length > 0 ||
      organisationErrors?.length > 0 ||
      successorCrossRefErrors?.length > 0 ||
      noteErrors?.length > 0;
    setPropertyHasErrors(newHasErrors);

    if (creatingPropertyRangeRef.current && newHasErrors) {
      const newRangeErrors = rangePropertyErrorsRef.current.concat([{ ...newErrors, propertyHasErrors: newHasErrors }]);
      rangePropertyErrorsRef.current = newRangeErrors;
      setRangePropertyErrors(newRangeErrors);
    }

    if (!reloading) {
      sessionStorage.setItem(
        "propertyErrors",
        JSON.stringify({
          pkId: pkId,
          blpu: blpuErrors && blpuErrors.length > 0 ? blpuErrors : [],
          lpi: lpiErrors && lpiErrors.length > 0 ? lpiErrors : [],
          provenance: provenanceErrors && provenanceErrors.length > 0 ? provenanceErrors : [],
          crossRef: crossRefErrors && crossRefErrors.length > 0 ? crossRefErrors : [],
          classification: classificationErrors && classificationErrors.length > 0 ? classificationErrors : [],
          organisation: organisationErrors && organisationErrors.length > 0 ? organisationErrors : [],
          successorCrossRef:
            successorCrossRefErrors && successorCrossRefErrors.length > 0 ? successorCrossRefErrors : [],
          note: noteErrors && noteErrors.length > 0 ? noteErrors : [],
        })
      );
    }
  }

  /**
   * Method used to handle when we are updating properties in bulk.
   *
   * @param {Array} errors The list of errors that occurred during the bulk update of properties.
   */
  function HandleBulkUpdatePropertiesError(errors) {
    setBulkUpdatePropertiesError(errors);
  }

  /**
   * Method used to handle when we are leaving the current property to go to a new street or property.
   *
   * @param {string|null} why The reason why we are leaving the current property.
   * @param {object|null} information The information required to use when leaving the property.
   */
  function HandleLeavingProperty(why, information) {
    if (why) setLeavingProperty({ why: why, information: information });
    else setLeavingProperty(null);
  }

  /**
   * Event to handle setting a field as the currently active control.
   *
   * @param {number} type The type of record.
   * @param {number} index The index of the record with the array.
   * @param {string} fieldName The field name used to determine which control to go to.
   */
  function HandlePropertyGoToField(type, index, fieldName) {
    if (type === null) setPropertyGoToField(null);
    else setPropertyGoToField({ type: type, index: index, fieldName: fieldName });
  }

  /**
   * Event to handle the change of a property.
   *
   * @param {number} type The record type.
   * @param {number} index The index of the record within its array.
   * @param {boolean} [newRecord=false] True if this is a new record; otherwise false.
   */
  function HandlePropertyRecordChange(type, index, newRecord = false) {
    setPropertyRecord({ type: type, index: index, newRecord: newRecord });
    if (newRecord) setNewPropertyRecordType(true);

    sessionStorage.setItem("propertyRecord", JSON.stringify({ type: type, index: index, newRecord: newRecord }));
  }

  /**
   * Event to handle when the number of children the property has changes.
   *
   * @param {Number} childCount The number of children the property has.
   */
  function HandleChildCountChange(childCount) {
    setChildCount(childCount);
    sessionStorage.setItem("propertyChildCount", childCount);
  }

  /**
   * Event to handle setting a flag to say if the provenance record has been modified.
   *
   * @param {boolean} changed True if the provenance data has been modified; otherwise false.
   */
  function HandleProvenanceDataChange(changed) {
    setProvenanceDataChanged(changed);
  }

  /**
   * Event to handle when the wizard is done.
   *
   * @param {object} data The wizard data.
   * @param {boolean} isRange True if creating a range of properties/children.
   * @param {object|null} parent If creating children this is the parent object.
   * @param {object} source The source data.
   */
  function HandleWizardDone(data, isRange, parent, source) {
    setWizardData({ ...data, isRange: isRange, parent: parent, source: source });

    // sessionStorage.setItem("wizardData", JSON.stringify({ ...data, isRange: isRange, parent: parent, source: source }));
  }

  /**
   * Event to handle when clearing the wizard data.
   */
  function HandleClearWizardData() {
    HandleWizardDone(null, false, null, null);
  }

  /**
   * Event to handle the resetting of the property.
   */
  function HandleResetProperty() {
    previousProperty.current = property;
    HandlePropertyChange(0, 0, "", "", "", 0, 0, false, null, null);
    setLogicalStatus(null);
  }

  /**
   * Event to handle the restoring of the property state object.
   */
  function HandleRestoreProperty() {
    setProperty(previousProperty.current);
    sessionStorage.setItem("property", JSON.stringify(previousProperty.current));
  }

  /**
   * Event to handle when the property is opened at the related tab.
   */
  function HandlePropertyRelatedOpened() {
    setProperty({
      uprn: property.uprn,
      usrn: property.usrn,
      address: property.address,
      formattedAddress: property.formattedAddress,
      postcode: property.postcode,
      easting: property.easting,
      northing: property.northing,
      newProperty: property.newProperty,
      parent: property.parent,
      openRelated: null,
    });

    sessionStorage.setItem(
      "property",
      JSON.stringify({
        uprn: property.uprn,
        usrn: property.usrn,
        address: property.address,
        formattedAddress: property.formattedAddress,
        postcode: property.postcode,
        easting: property.easting,
        northing: property.northing,
        newProperty: property.newProperty,
        parent: property.parent,
        openRelated: null,
      })
    );
  }

  /**
   * Event to handle resetting of the property errors.
   */
  function HandleResetPropertyErrors(isRange, clearRange) {
    setPropertyErrors({
      pkId: null,
      blpu: [],
      lpi: [],
      provenance: [],
      crossRef: [],
      classification: [],
      organisation: [],
      successorCrossRef: [],
      note: [],
    });
    setPropertyHasErrors(false);
    setCreatingPropertyRange(isRange);
    creatingPropertyRangeRef.current = isRange;
    if (isRange && clearRange) {
      rangePropertyErrorsRef.current = [];
      setRangePropertyErrors([]);
    }

    sessionStorage.setItem(
      "propertyErrors",
      JSON.stringify({
        blpu: [],
        lpi: [],
        provenance: [],
        crossRef: [],
        classification: [],
        organisation: [],
        successorCrossRef: [],
        note: [],
      })
    );
  }

  /**
   * Event to handle the validation of the property data.
   *
   * @returns True if the data is valid; otherwise false.
   */
  function HandlePropertyValidateData() {
    let isValid = true;

    const updatePropertyErrors = (newErrors, type) => {
      HandlePropertyErrors(
        type === "blpu" ? newErrors : propertyErrors.blpu,
        type === "lpi" ? newErrors : propertyErrors.lpi,
        type === "provenance" ? newErrors : propertyErrors.provenance,
        type === "crossRef" ? newErrors : propertyErrors.crossRef,
        type === "classification" ? newErrors : propertyErrors.classification,
        type === "organisation" ? newErrors : propertyErrors.organisation,
        type === "successorCrossRef" ? newErrors : propertyErrors.successorCrossRef,
        type === "note" ? newErrors : propertyErrors.note
      );
    };

    if (propertyModified) {
      switch (propertyRecord.type) {
        case 21:
          if (currentProperty) {
            const blpuData = {
              blpuStateDate: currentProperty.blpuStateDate,
              rpc: currentProperty.rpc,
              startDate: currentProperty.startDate,
              endDate: currentProperty.endDate,
              neverExport: currentProperty.neverExport,
              siteSurvey: currentProperty.siteSurvey,
              uprn: currentProperty.uprn,
              parentUprn: currentProperty.parentUprn,
              logicalStatus: currentProperty.logicalStatus,
              blpuState: currentProperty.blpuState,
              level: currentProperty.level,
              blpuClass: currentProperty.blpuClass,
              organisation: currentProperty.organisation,
              xcoordinate: currentProperty.xcoordinate,
              ycoordinate: currentProperty.ycoordinate,
              wardCode: currentProperty.wardCode,
              parishCode: currentProperty.parishCode,
              localCustodianCode: isScottishRef.current
                ? currentProperty.custodianCode
                : currentProperty.localCustodianCode,
            };
            const blpuErrors = ValidateBlpuData(blpuData, lookups, isScottishRef.current);
            isValid = blpuErrors.length === 0;
            updatePropertyErrors(blpuErrors, "blpu");
          }
          break;

        case 22:
          if (currentProvenanceRecord) {
            const provenanceErrors = ValidateProvenanceData(
              currentProvenanceRecord,
              propertyRecord.index,
              lookups,
              isScottishRef.current
            );
            isValid = provenanceErrors.length === 0;
            updatePropertyErrors(provenanceErrors, "provenance");
          }
          break;

        case 23:
          if (currentAppCrossRefRecord) {
            const crossRefErrors = ValidateCrossRefData(
              currentAppCrossRefRecord,
              propertyRecord.index,
              lookups,
              isScottishRef.current
            );
            isValid = crossRefErrors.length === 0;
            updatePropertyErrors(crossRefErrors, "crossRef");
          }
          break;

        case 24:
          if (currentLpiRecord) {
            const lpiErrors = ValidateLpiData(
              currentLpiRecord,
              propertyRecord.index,
              lookups,
              isScottishRef.current,
              isWelshRef.current
            );
            isValid = lpiErrors.length === 0;
            updatePropertyErrors(lpiErrors, "lpi");
          }
          break;

        case 30:
          if (currentSuccessorCrossRefRecord) {
            const successorCrossRefErrors = ValidateSuccessorCrossRefData(
              currentSuccessorCrossRefRecord,
              propertyRecord.index,
              lookups
            );
            isValid = successorCrossRefErrors.length === 0;
            updatePropertyErrors(successorCrossRefErrors, "successorCrossRef");
          }
          break;

        case 31:
          if (currentOrganisationRecord) {
            const organisationErrors = ValidateOrganisationData(
              currentOrganisationRecord,
              propertyRecord.index,
              lookups
            );
            isValid = organisationErrors.length === 0;
            updatePropertyErrors(organisationErrors, "organisation");
          }
          break;

        case 32:
          if (currentClassificationRecord) {
            const classificationErrors = ValidateClassificationData(
              currentClassificationRecord,
              propertyRecord.index,
              lookups
            );
            isValid = classificationErrors.length === 0;
            updatePropertyErrors(classificationErrors, "classification");
          }
          break;

        case 71:
          if (currentPropertyNoteRecord) {
            const noteErrors = ValidatePropertyNoteData(
              currentPropertyNoteRecord,
              propertyRecord.index,
              lookups,
              isScottishRef.current
            );
            isValid = noteErrors.length === 0;
            updatePropertyErrors(noteErrors, "note");
          }
          break;

        default:
          break;
      }
    }

    return isValid;
  }

  /**
   * Event to handle reloading the property context data from storage
   */
  function HandlePropertyReload() {
    if (sessionStorage.getItem("property") !== null && Number(property.uprn) === 0 && Number(property.usrn) === -1) {
      const savedProperty = JSON.parse(sessionStorage.getItem("property"));
      HandlePropertyChange(
        savedProperty.uprn,
        savedProperty.usrn,
        savedProperty.address,
        savedProperty.formattedAddress,
        savedProperty.postcode,
        savedProperty.easting,
        savedProperty.northing,
        savedProperty.newProperty,
        savedProperty.parent,
        savedProperty.openRelated,
        true
      );
    }
    if (
      sessionStorage.getItem("propertyErrors") !== null &&
      propertyErrors.blpu.length === 0 &&
      propertyErrors.lpi.length === 0 &&
      propertyErrors.provenance.length === 0 &&
      propertyErrors.crossRef.length === 0 &&
      propertyErrors.classification.length === 0 &&
      propertyErrors.organisation.length === 0 &&
      propertyErrors.successorCrossRef.length === 0 &&
      propertyErrors.note.length === 0
    ) {
      const savedPropertyErrors = JSON.parse(sessionStorage.getItem("propertyErrors"));
      HandlePropertyErrors(
        savedPropertyErrors.blpu,
        savedPropertyErrors.lpi,
        savedPropertyErrors.provenance,
        savedPropertyErrors.crossRef,
        savedPropertyErrors.classification,
        savedPropertyErrors.organisation,
        savedPropertyErrors.successorCrossRef,
        savedPropertyErrors.note,
        savedPropertyErrors.pkId,
        true
      );
    }
    if (sessionStorage.getItem("propertyRecord") !== null && propertyRecord.type === 21 && !propertyRecord.index) {
      const savedPropertRecord = JSON.parse(sessionStorage.getItem("propertyRecord"));
      setPropertyRecord({
        type: savedPropertRecord.type,
        index: savedPropertRecord.index,
        newRecord: savedPropertRecord.newRecord,
      });
    }
    if (sessionStorage.getItem("propertyChildCount") !== null) {
      setChildCount(Number(sessionStorage.getItem("propertyChildCount")));
    }
  }
  //endregion propertyContext

  //region mapContext
  /**
   * Event to handle when background mapping data changes.
   *
   * @param {Array} streets The list of background streets.
   * @param {Array} unassignedEsus The list of unassigned ESUs.
   * @param {Array} properties The list of background properties.
   * @param {Array} provenances The list of background provenances.
   */
  function HandleBackgroundDataChange(streets, unassignedEsus, properties, provenances) {
    setBackgroundData({
      streets: streets,
      unassignedEsus: unassignedEsus,
      properties: properties,
      provenances: provenances,
    });
  }

  /**
   * Event to handle when the mapping data changes for a search.
   *
   * @param {Array|null} streets The list of streets returned by the search.
   * @param {Array|null} llpgStreets The list of LLPG streets returned by the search.
   * @param {Array|null} properties The list of properties returned by the search.
   * @param {number|null} editStreet The USRN of the street that is being edited.
   * @param {number|null} editProperty The UPRN of the property that is being edited.
   */
  function HandleMapSearchDataChange(streets, llpgStreets, properties, editStreet, editProperty, reloading = false) {
    setMapSearchData({
      streets: streets,
      llpgStreets: llpgStreets,
      properties: properties,
      editStreet: editStreet,
      editProperty: editProperty,
    });

    if (!editStreet && editStreet !== 0 && !editProperty && editProperty !== 0) {
      setSourceMapSearchData({ streets: streets, llpgStreets: llpgStreets, properties: properties });
    }

    if (!reloading) {
      sessionStorage.setItem("mapSearchData", JSON.stringify({ editStreet: editStreet, editProperty: editProperty }));
    }
  }

  /**
   * Event to handle when the map changes.
   *
   * @param {array|null} extents The list of extents to display for the current property.
   * @param {number|null} zoomStreet The USRN of the street to zoom to.
   * @param {number|null} zoomProperty The UPRN of the property to zoom to.
   * @param {object|null} zoomGroup The list of USRNs and UPRNs to zoom to.
   */
  function HandleMapChange(extents, zoomStreet, zoomProperty, zoomGroup = null) {
    setMap({
      extents: extents,
      zoomStreet: zoomStreet,
      zoomProperty: zoomProperty,
      zoomGroup: zoomGroup,
    });

    sessionStorage.setItem(
      "map",
      JSON.stringify({
        extents: extents,
        zoomStreet: zoomStreet,
        zoomProperty: zoomProperty,
        zoomGroup: zoomGroup,
      })
    );
  }

  /**
   * Event to handle when the property changes.
   *
   * @param {object} property The current property.
   */
  function HandleMapPropertyChange(property) {
    setMapProperty(property);
  }

  /**
   * Event to handle when the street changes.
   *
   * @param {object} street The current street.
   */
  function HandleMapStreetChange(street) {
    setMapStreet(street);
  }

  /**
   * Event to handle editing a map object.
   *
   * @param {number} objectType The type of map object being edited.
   * @param {number} objectId The id of the object being edited.
   */
  function HandleEditMapObject(objectType, objectId, reloading = false) {
    if (!objectType && editObjectRef.current) {
      setEditObject(null);
      editObjectRef.current = null;
      setCreateToolActivated(false);
      if (!reloading) {
        sessionStorage.setItem("editObject", JSON.stringify({ objectType: objectType, objectId: objectId }));
      }
    } else if (
      objectType &&
      objectId &&
      (!editObjectRef.current ||
        editObjectRef.current.objectType !== objectType ||
        editObjectRef.current.objectId !== objectId)
    ) {
      setEditObject({ objectType: objectType, objectId: objectId });
      editObjectRef.current = { objectType: objectType, objectId: objectId };
      setRefreshSketchLayer(true);
      if (!reloading) {
        sessionStorage.setItem("editObject", JSON.stringify({ objectType: objectType, objectId: objectId }));
      }
    }
  }

  /**
   * Method to get all the streets within a given extent.
   *
   * @param {object} extent The extent of the map
   * @returns {array} The list of streets within the given extent.
   */
  async function GetBackgroundStreetData(extent) {
    if (!currentUserRef.current || extent.zoomLevel < 16) return null;

    const backgroundStreetsUrl = GetBackgroundStreetsUrl(currentUserRef.current);

    if (backgroundStreetsUrl) {
      const returnValue = await fetch(
        `${backgroundStreetsUrl.url}?XMin=${extent.xmin}&YMin=${extent.ymin}&XMax=${extent.xmax}&YMax=${extent.ymax}`,
        {
          headers: backgroundStreetsUrl.headers,
          crossDomain: true,
          method: "GET",
        }
      )
        .then((res) => (res.ok ? res : Promise.reject(res)))
        .then((res) => {
          if (res.status && res.status === 204) return [];
          else return res.json();
        })
        .then((result) => {
          return result;
        })
        .catch((res) => {
          switch (res.status) {
            case 400:
              res.json().then((body) => {
                if (userShowMessages.current) console.error(`[400 ERROR] Getting all Street data`, body.errors);
              });
              return null;

            case 401:
              HandleAuthorisationExpired();
              return null;

            case 500:
              if (userShowMessages.current) console.error(`[500 ERROR] Getting all Street data`, res);
              return null;

            default:
              if (userShowMessages.current) console.error(`[${res.status} ERROR] Getting all Street data`, res);
              return null;
          }
        });

      return returnValue;
    } else return null;
  }

  /**
   * Method to get all the unassigned ESUs within a given extent.
   *
   * @param {object} extent The extent of the map
   * @returns {Array} The list of unassigned ESUs within the given extent.
   */
  async function GetUnassignedEsuData(extent) {
    if (!currentUserRef.current || extent.zoomLevel < 16) return null;
    const unassignedEsusUrl = GetUnassignedEsusUrl(currentUserRef.current);

    if (unassignedEsusUrl) {
      const returnValue = await fetch(
        `${unassignedEsusUrl.url}?XMin=${extent.xmin}&YMin=${extent.ymin}&XMax=${extent.xmax}&YMax=${extent.ymax}`,
        {
          headers: unassignedEsusUrl.headers,
          crossDomain: true,
          method: "GET",
        }
      )
        .then((res) => (res.ok ? res : Promise.reject(res)))
        .then((res) => {
          if (res.status && res.status === 204) return [];
          else return res.json();
        })
        .then((result) => {
          return result;
        })
        .catch((res) => {
          switch (res.status) {
            case 400:
              res.json().then((body) => {
                if (userShowMessages.current) console.error(`[400 ERROR] Getting all unassigned ESU data`, body.errors);
              });
              return null;

            case 401:
              HandleAuthorisationExpired();
              return null;

            case 500:
              if (userShowMessages.current) console.error(`[500 ERROR] Getting all unassigned ESU data`, res);
              return null;

            default:
              if (userShowMessages.current) console.error(`[${res.status} ERROR] Getting all unassigned ESU data`, res);
              return null;
          }
        });

      return returnValue;
    } else return null;
  }

  /**
   * Method to get all the properties within a given extent.
   *
   * @param {object} extent The extent of the map
   * @returns {array} The list of properties within the given extent.
   */
  async function GetBackgroundPropertyData(extent) {
    if (!currentUserRef.current || extent.zoomLevel < 16) return null;

    const backgroundPropertiesUrl = GetBackgroundPropertiesUrl(currentUserRef.current);

    if (backgroundPropertiesUrl) {
      const returnValue = await fetch(
        `${backgroundPropertiesUrl.url}?XMin=${extent.xmin}&YMin=${extent.ymin}&XMax=${extent.xmax}&YMax=${extent.ymax}`,
        {
          headers: backgroundPropertiesUrl.headers,
          crossDomain: true,
          method: "GET",
        }
      )
        .then((res) => (res.ok ? res : Promise.reject(res)))
        .then((res) => {
          if (res.status && res.status === 204) return [];
          else return res.json();
        })
        .then((result) => {
          return result;
        })
        .catch((res) => {
          switch (res.status) {
            case 400:
              res.json().then((body) => {
                if (userShowMessages.current) console.error(`[400 ERROR] Getting all property data`, body.errors);
              });
              return null;

            case 401:
              HandleAuthorisationExpired();
              return null;

            case 500:
              if (userShowMessages.current) console.error(`[500 ERROR] Getting all property data`, res);
              return null;

            default:
              if (userShowMessages.current) console.error(`[${res.status} ERROR] Getting all property data`, res);
              return null;
          }
        });

      return returnValue;
    } else return null;
  }

  /**
   * Method to get all the properties within a given extent.
   *
   * @param {object} extent The extent of the map
   * @returns {array} The list of properties within the given extent.
   */
  async function GetBackgroundProvenanceData(extent) {
    if (!currentUserRef.current || extent.zoomLevel < 16) return null;

    const backgroundProvenancesUrl = GetBackgroundProvenancesUrl(currentUserRef.current);

    if (backgroundProvenancesUrl) {
      const returnValue = await fetch(
        `${backgroundProvenancesUrl.url}?XMin=${extent.xmin}&YMin=${extent.ymin}&XMax=${extent.xmax}&YMax=${extent.ymax}`,
        {
          headers: backgroundProvenancesUrl.headers,
          crossDomain: true,
          method: "GET",
        }
      )
        .then((res) => (res.ok ? res : Promise.reject(res)))
        .then((res) => {
          if (res.status && res.status === 204) return [];
          else return res.json();
        })
        .then((result) => {
          return result;
        })
        .catch((res) => {
          switch (res.status) {
            case 400:
              res.json().then((body) => {
                if (userShowMessages.current) console.error(`[400 ERROR] Getting all provenance data`, body.errors);
              });
              return null;

            case 401:
              HandleAuthorisationExpired();
              return null;

            case 500:
              if (userShowMessages.current) console.error(`[500 ERROR] Getting all provenance data`, res);
              return null;

            default:
              if (userShowMessages.current) console.error(`[${res.status} ERROR] Getting all provenance data`, res);
              return null;
          }
        });

      return returnValue;
    } else return null;
  }

  /**
   * Event to handle when the map extent changes.
   *
   * @param {object} extent The extent for the map
   * @returns
   */
  async function HandleExtentChange(extent, reloading = false) {
    if (
      !extent ||
      (currentMapExtent.current &&
        currentMapExtent.current.zoom === extent.zoom &&
        currentMapExtent.current.xmin === extent.xmin &&
        currentMapExtent.current.ymin === extent.ymin &&
        currentMapExtent.current.xmax === extent.xmax &&
        currentMapExtent.current.ymax === extent.ymax)
    )
      return;

    try {
      currentMapExtent.current = {
        xmin: extent.xmin,
        ymin: extent.ymin,
        xmax: extent.xmax,
        ymax: extent.ymax,
        zoom: extent.zoom,
      };

      setUpdatingMap((prev) => (prev < 0 ? 1 : prev + 1));
      setMapExtent(extent);

      if (!reloading) {
        sessionStorage.setItem("mapExtent", JSON.stringify(extent));
      }

      let backgroundStreetData = null;
      let unassignedEsuData = null;
      let backgroundPropertyData = null;
      let backgroundProvenanceData = null;

      if (
        extent.zoom > 15 ||
        ((extent.zoom === -1 || !extent.zoom) && (extent.xmax - extent.xmin < 400 || extent.ymax - extent.ymin < 400)) //&&
        // (!currentMapExtent.current ||
        //   currentMapExtent.current.zoom !== extent.zoom ||
        //   (currentMapExtent.current.zoom === extent.zoom &&
        //     (currentMapExtent.current.xmin !== extent.xmin ||
        //       currentMapExtent.current.ymin !== extent.ymin ||
        //       currentMapExtent.current.xmax !== extent.xmax ||
        //       currentMapExtent.current.ymax !== extent.ymax)))
      ) {
        backgroundStreetData = await GetBackgroundStreetData(extent);
        unassignedEsuData = await GetUnassignedEsuData(extent);

        if (extent.hasProperties) {
          backgroundPropertyData = await GetBackgroundPropertyData(extent);
          backgroundProvenanceData = await GetBackgroundProvenanceData(extent);
        } else {
          backgroundPropertyData = [];
          backgroundProvenanceData = [];
        }
      } else {
        backgroundStreetData = [];
        unassignedEsuData = [];
        backgroundPropertyData = [];
        backgroundProvenanceData = [];
      }

      if (backgroundStreetData?.length > 0 || backgroundPropertyData?.length > 0) {
        HandleBackgroundDataChange(
          backgroundStreetData,
          unassignedEsuData,
          backgroundPropertyData,
          backgroundProvenanceData
        );
      }
    } finally {
      setUpdatingMap((prev) => (prev > 0 ? prev - 1 : 0));
    }
  }

  /**
   * Event to handle highlighting a street or property on the map.
   *
   * @param {object|null} street The street to highlight
   * @param {object|null} property Th property to highlight
   */
  function HandleStreetPropertyHighlight(street, property) {
    if (!selectingProperties) {
      setHighlight({
        street: street,
        esu: null,
        asd51: null,
        asd52: null,
        asd53: null,
        asd61: null,
        asd62: null,
        asd63: null,
        asd64: null,
        asd66: null,
        property: property,
        selectProperties: null,
        extent: null,
      });
    }
  }

  /**
   * Event to handle highlighting items on the map.
   *
   * @param {string} type The type of item to highlight.
   * @param {array} array The array of items that need to be highlighted.
   */
  function HandleListItemHighlight(type, array) {
    setHighlight({
      street: null,
      esu: type === "esu" ? array : null,
      asd51: type === "asd51" ? array : null,
      asd52: type === "asd52" ? array : null,
      asd53: type === "asd53" ? array : null,
      asd61: type === "asd61" ? array : null,
      asd62: type === "asd62" ? array : null,
      asd63: type === "asd63" ? array : null,
      asd64: type === "asd64" ? array : null,
      asd66: type === "asd66" ? array : null,
      property: null,
      selectProperties: type === "selectProperties" ? array : null,
      extent: type === "extent" ? array : null,
    });
  }

  /**
   * Event to handle clearing any highlights on the map.
   */
  function HandleClearHighlight() {
    setHighlight({
      street: [],
      esu: [],
      asd51: [],
      asd52: [],
      asd53: [],
      asd61: [],
      asd62: [],
      asd63: [],
      asd64: [],
      asd66: [],
      property: [],
      selectProperties: [],
      extent: [],
    });
  }

  /**
   * Event to handle setting coordinates.
   *
   * @param {object|null} point The point coordinates to use.
   */
  function HandleSetCoordinate(point) {
    if (!point) {
      setMapStreetStart(null);
      setMapStreetEnd(null);
      setMapPropertyPin(null);
      setMapDivideEsu(null);
    } else {
      switch (pointCaptureModeRef.current) {
        case "streetStart":
          setMapStreetStart(point);
          break;

        case "streetEnd":
          setMapStreetEnd(point);
          break;

        default:
          setMapPropertyPin(point);
          break;
      }
    }
    HandlePointCapture(null);
  }

  /**
   * Event to handle setting the coordinates from the wizard.
   * @param {object} data The point object.
   */
  function HandleWizardSetCoordinate(data) {
    if (!data) {
      setWizardPoint(null);
    } else {
      setWizardPoint(data);
    }
  }

  /**
   * Event to handle when a line has been drawn on the map.
   *
   * @param {string} wktGeometry The WKT geometry of the line.
   */
  function HandleSetLineGeometry(wktGeometry, clearLineGeometry = false) {
    setUpdatingEsuGeometry(wktGeometry !== "");
    if (clearLineGeometry) {
      setMapLineGeometry(null);
    } else if (!wktGeometry || !wktGeometry.includes(",")) {
      setMapLineGeometry({
        wktGeometry: null,
        objectType: editObjectRef.current ? editObjectRef.current.objectType : null,
        objectId: editObjectRef.current ? editObjectRef.current.objectId : null,
      });
    } else {
      setMapLineGeometry({
        wktGeometry: wktGeometry,
        objectType: editObjectRef.current ? editObjectRef.current.objectType : null,
        objectId: editObjectRef.current ? editObjectRef.current.objectId : null,
      });
    }
  }

  /**
   * Event to handle refreshing the ESU geometry.
   */
  function HandleRefreshEsuGeometry() {
    setRefreshEsuGeometry(true);
  }

  /**
   * Event to handle when a polygon has been drawn on the map.
   *
   * @param {string} wktGeometry The WKT geometry of the polygon.
   */
  function HandleSetPolygonGeometry(wktGeometry) {
    setUpdatingProvenance(wktGeometry !== "");
    if (wktGeometry === "") {
      // Deleting the geometry
      setMapPolygonGeometry({
        wktGeometry: "",
        objectType: editObjectRef.current ? editObjectRef.current.objectType : null,
        objectId: editObjectRef.current ? editObjectRef.current.objectId : null,
      });
    } else if (!wktGeometry || !wktGeometry.includes(",") || (wktGeometry.match(/,/g) || []).length < 3) {
      // Only set a polygon if we have a minimum of 3 unique points (triangle)
      setMapPolygonGeometry(null);
    } else {
      setMapPolygonGeometry({
        wktGeometry: wktGeometry,
        objectType: editObjectRef.current ? editObjectRef.current.objectType : null,
        objectId: editObjectRef.current ? editObjectRef.current.objectId : null,
      });
    }
  }

  /**
   * Event to handle refreshing the polygon geometry.
   */
  function HandleRefreshPolygonGeometry() {
    setRefreshProvenance(true);
  }

  /**
   * Event to handle capturing a point from the map.
   *
   * @param {string} mode The type of point capture required.
   */
  function HandlePointCapture(mode) {
    setPointCaptureMode(mode);
    pointCaptureModeRef.current = mode;
  }

  /**
   * Event to handle when a property pin is selected.
   *
   * @param {object} pin The property pin that has been selected.
   */
  function HandlePinSelected(pin) {
    setSelectedPin(pin);
  }

  /**
   * Method to handle when an ESU is selected to be divided.
   *
   * @param {number} esuId The ESU id that is to be divided.
   */
  function HandleDivideEsu(esuId) {
    if (esuId) {
      HandleEditMapObject(13, esuId);
      HandlePointCapture("divideEsu");
    } else {
      HandleEditMapObject(null, null);
      HandlePointCapture(null);
    }
  }

  /**
   * Method to handle when an ESU has been divided.
   *
   * @param {Array} esuGeometry1 The array of points for the first new ESU.
   * @param {Array} esuGeometry2 The array of points for the second new ESU.
   */
  function HandleEsuDivided(esuGeometry1, esuGeometry2) {
    setMapDivideEsu({ esuId: editObjectRef.current.objectId, newEsu1: esuGeometry1, newEsu2: esuGeometry2 });
  }

  /**
   * Method to handle selecting ESUs from the map.
   */
  function HandleSelectEsus() {
    HandlePointCapture("assignEsu");
  }

  /**
   * Method to handle when the user wants to select properties from the map.
   *
   * @param {Boolean} selecting If true user wants to select properties from the map; otherwise false.
   */
  function HandleSelectPropertiesChange(selecting) {
    setSelectingProperties(selecting);
    HandlePointCapture(selecting ? "selectProperties" : null);
  }

  /**
   * Method to handle when a shape file is loaded.
   *
   * @param {string} geojson The string representation of the geojson data from the SHP file.
   * @param {object} shpFile The object containing the information for the shp file that has just been loaded.
   * @param {object} shpRenderer The renderer to use for the shp file.
   * @param {string} [popupTitleField=""] The field to use for the popup title.
   */
  function HandleLoadShpFile(geojson, shpFile, shpRenderer, popupTitleField = "") {
    if (geojson && shpFile) {
      // Get the fields from the geojson properties
      const fields = [];
      let parsedGeojson = typeof geojson === "string" ? JSON.parse(geojson) : geojson;
      let geometryType = null;
      if (parsedGeojson.type && parsedGeojson.type === "FeatureCollection" && parsedGeojson.features.length > 0) {
        geometryType = parsedGeojson.features[0].geometry.type.toLowerCase();
      }

      if (geometryType === "multipolygon") geometryType = "polygon";
      if (geometryType === "multilinestring" || geometryType === "line" || geometryType === "linestring")
        geometryType = "polyline";
      if (geometryType === "multipoint") geometryType = "point";

      for (const feature of parsedGeojson.features) {
        for (const [key, value] of Object.entries(feature.properties)) {
          if (!fields.find((field) => field.name === key)) {
            fields.push({
              name: key,
              alias: StringToTitleCase(key.replaceAll("_", " ")),
              type:
                key.toLowerCase() === "objectid"
                  ? "oid"
                  : typeof value === "number"
                    ? Number.isInteger(value)
                      ? "integer"
                      : "double"
                    : typeof value,
            });
          }
        }
      }

      // Ensure we have an ObjectID field
      if (!fields.find((field) => field.type === "oid")) {
        fields.push({ name: "ObjectID", alias: "ObjectID", type: "oid" });
        parsedGeojson = {
          ...parsedGeojson,
          features: parsedGeojson.features.map((f, idx) => ({
            ...f,
            properties: { ...f.properties, ObjectID: idx + 1 },
          })),
        };
      }

      let newLoadedShpFiles = loadedShpFiles.map((x) => x);
      if (!loadedShpFiles.find((x) => x.id === shpFile.layerId)) {
        newLoadedShpFiles.push({
          id: shpFile.layerId,
          geojson: JSON.stringify(parsedGeojson),
          shpFile: shpFile,
          renderer: shpRenderer,
          fields: fields,
          geometryType: geometryType,
          popupTitleField: popupTitleField,
        });
      } else {
        newLoadedShpFiles = loadedShpFiles.map(
          (x) =>
            [
              {
                id: shpFile.layerId,
                geojson: JSON.stringify(parsedGeojson),
                shpFile: shpFile,
                renderer: shpRenderer,
                fields: fields,
                geometryType: geometryType,
                popupTitleField: popupTitleField,
              },
            ].find((rec) => rec.id === x.id) || x
        );
      }
      setLoadedShpFiles(newLoadedShpFiles);
      setAddShpFilesToMap(true);
      currentShpFiles.current = newLoadedShpFiles;
    }
  }

  /**
   * Method to handle when a shape file is loaded.
   *
   * @param {string} imageUrl The image data URL.
   * @param {object} geoFile The object containing the information for the georeferenced file that has just been loaded.
   * @param {object} worldData The world file data for the georeferenced file.
   */
  function HandleLoadGeoFile(imageUrl, geoFile, worldData = null) {
    if (imageUrl && geoFile) {
      let newLoadedGeoFiles = loadedGeoFiles.map((x) => x);
      if (!loadedGeoFiles.find((x) => x.id === geoFile.layerId)) {
        newLoadedGeoFiles.push({
          id: geoFile.layerId,
          imageUrl: imageUrl,
          geoFile: geoFile,
          worldData: worldData,
        });
      } else {
        newLoadedGeoFiles = loadedGeoFiles.map(
          (x) =>
            [
              {
                id: geoFile.layerId,
                imageUrl: imageUrl,
                geoFile: geoFile,
                worldData: worldData,
              },
            ].find((rec) => rec.id === x.id) || x
        );
      }
      setLoadedGeoFiles(newLoadedGeoFiles);
      setAddGeoFilesToMap(true);
      currentGeoFiles.current = newLoadedGeoFiles;
    }
  }

  /**
   * Method to handle when a shape file is unloaded.
   *
   * @param {string} id The id of for the shp file that we want to unload.
   */
  function HandleUnloadShpFile(id) {
    if (id) {
      const newLoadedShpFiles = currentShpFiles.current.filter((x) => x.id !== id);
      setLoadedShpFiles(newLoadedShpFiles);
      currentShpFiles.current = newLoadedShpFiles;
    }
  }

  /**
   * Method to handle when a geo-referenced file is unloaded.
   *
   * @param {string} id The id of for the geo-referenced file that we want to unload.
   */
  function HandleUnloadGeoFile(id) {
    if (id) {
      const newLoadedGeoFiles = currentGeoFiles.current.filter((x) => x.id !== id);
      setLoadedGeoFiles(newLoadedGeoFiles);
      currentGeoFiles.current = newLoadedGeoFiles;
    }
  }

  /**
   * Event to handle reloading the map context data from storage
   */
  function HandleMapReload() {
    if (
      sessionStorage.getItem("map") !== null &&
      map.extents &&
      map.extents.length === 0 &&
      !map.zoomStreet &&
      !map.zoomProperty
    ) {
      setMap(JSON.parse(sessionStorage.getItem("map")));
    }
    if (sessionStorage.getItem("editObject") !== null && !editObject) {
      const savedEditObject = JSON.parse(sessionStorage.getItem("editObject"));
      HandleEditMapObject(savedEditObject.objectType, savedEditObject.objectId, true);
    }
    if (sessionStorage.getItem("mapExtent") !== null && !mapExtent) {
      HandleExtentChange(JSON.parse(sessionStorage.getItem("mapExtent")), true);
    }
    if (localStorage.getItem("currentBaseMapId") !== null && !activeBaseMap) {
      const savedBaseMapId = JSON.parse(localStorage.getItem("currentBaseMapId"));
      setActiveBaseMap(savedBaseMapId);
    }
  }

  /**
   * Handle when updating an ESU geometry.
   *
   * @param {Boolean} updating True when an ESU geometry is being updated.
   */
  function HandleUpdatingEsuGeometry(updating) {
    setUpdatingEsuGeometry(updating);
    if (!updating && refreshEsuGeometry) {
      setRefreshEsuGeometry(false);
    }
  }

  /**
   * Handle when updating a provenance record.
   *
   * @param {Boolean} updating True when a provenance record is being updated.
   */
  function HandleUpdatingProvenance(updating) {
    setUpdatingProvenance(updating);
    if (!updating && refreshProvenance) {
      setRefreshProvenance(false);
    }
  }

  /**
   * Handle when setting flag for activating the create tool.
   *
   * @param {Boolean} activated True when a provenance record is being merged.
   */
  function HandleCreateToolActivated(activated) {
    setCreateToolActivated(activated);
  }

  /**
   * Handle when need to view the authority extent.
   *
   * @param {Boolean} activated True when need to view the authority extent.
   */
  function HandleViewAuthorityExtent(viewAuthority) {
    setViewAuthorityExtent(viewAuthority);
  }

  /**
   * Handle when need to display the wizard map.
   *
   * @param {Boolean} displaying True when need to display the wizard map.
   */
  function HandleDisplayingWizardMapChange(displaying) {
    setDisplayingWizardMap(displaying);
    if (!displaying) {
      HandleSelectionVariantChange(previousSelectionVariantRef.current);
    }
  }

  /**
   * Method to handle when the base map is changed.
   *
   * @param {string} baseMapId The id of the new base map.
   */
  function HandleActiveBaseMapChange(baseMapId) {
    setActiveBaseMap(baseMapId);
    localStorage.setItem("currentBaseMapId", JSON.stringify(baseMapId));
  }
  //endregion mapContext

  //region informationContext
  /**
   * Method to handle when the display information should be shown.
   *
   * @param {string} type The type of information being displayed.
   * @param {string} source The source that is displaying the information.
   */
  function HandleDisplayInformation(type, source, reloading = false) {
    setInformationType(type);
    setInformationSource(source);

    switch (type) {
      case "createESU":
      case "manageESU":
      case "partRoadASD":
      case "inexactASD":
      case "managePolygon":
      case "createPolygon":
        setSketchToolVisibility({
          hideSketch: false,
          hideSketchLassoSelection: true,
          hideSketchRectangleSelection: true,
          hideSketchUndoRedoMenu: false,
          hideSketchDeleteButton: false,
        });
        break;

      case "divideESU":
      case "propertyWizard":
      case "moveBlpu":
      case "moveSeedPoint":
        setSketchToolVisibility({
          hideSketch: false,
          hideSketchLassoSelection: true,
          hideSketchRectangleSelection: true,
          hideSketchUndoRedoMenu: true,
          hideSketchDeleteButton: true,
        });
        break;

      case "selectProperties":
        setSketchToolVisibility({
          hideSketch: false,
          hideSketchLassoSelection: false,
          hideSketchRectangleSelection: false,
          hideSketchUndoRedoMenu: true,
          hideSketchDeleteButton: true,
        });
        break;

      default:
        setSketchToolVisibility({
          hideSketch: true,
          hideSketchLassoSelection: true,
          hideSketchRectangleSelection: true,
          hideSketchUndoRedoMenu: true,
          hideSketchDeleteButton: true,
        });
        break;
    }

    if (!reloading) {
      sessionStorage.setItem(
        "displayInformation",
        JSON.stringify({
          type: type,
          source: source,
        })
      );
    }
  }

  /**
   * Method to clear the information control.
   */
  function HandleClearInformation() {
    switch (informationType) {
      case "divideESU":
        HandleDivideEsu(null);
        break;

      default:
        break;
    }

    HandleDisplayInformation(null, null);
  }

  /**
   * Event to handle reloading the information context data from storage
   */
  function HandleInformationReload() {
    if (sessionStorage.getItem("displayInformation") !== null && !informationType && !informationSource) {
      const savedDisplayInformation = JSON.parse(sessionStorage.getItem("displayInformation"));
      HandleDisplayInformation(savedDisplayInformation.type, savedDisplayInformation.source, true);
    }
  }
  //endregion informationContext

  //region selectionContext
  /**
   * Method to handle when the selection variant changes.
   *
   * @param {string} variant The selection variant.
   */
  function HandleSelectionVariantChange(variant) {
    if (selectionVariantRef.current === variant) return;
    previousSelectionVariantRef.current = selectionVariantRef.current;
    selectionVariantRef.current = variant;
    setSelectionVariant(variant);
    if (variant === "") {
      HandleCloseSelection();
    }
  }

  /**
   * Method to handle when the selection control closes.
   */
  function HandleCloseSelection() {
    setSelectionVariant("");
    selectionVariantRef.current = "";
    setSelectionCount(0);
    setDialogSelectionCount(0);
    setCurrentStreetSelection(null);
    setCurrentEsuSelection([]);
    setCurrentPropertySelection(null);
    setCurrentAddressSelection("");
    setCurrentClassificationSelection([]);
    setCurrentOrganisationSelection([]);
    setCurrentSuccessorCrossRefSelection([]);
    setCurrentProvenanceSelection([]);
    setCurrentExtentSelection([]);
    setCurrentCrossReferenceSelection([]);
    setStreetUsrns([]);
    setPropertyUprns([]);
    setCloseControl(true);
  }
  //endregion selectionContext

  useEffect(() => {
    if (!currentUserRef.current && localStorage.getItem("currentUser") !== null) {
      const savedUser = JSON.parse(localStorage.getItem("currentUser"));
      if (savedUser.active && savedUser.expiry && hasLoginExpired(savedUser.expiry)) {
        HandleDisplayLogin();
      } else {
        HandleUserReload();
      }
    }

    if (!activeBaseMap && localStorage.getItem("currentBaseMapId") !== null) {
      const savedBaseMapId = JSON.parse(localStorage.getItem("currentBaseMapId"));
      HandleActiveBaseMapChange(savedBaseMapId);
    }
  });

  useEffect(() => {
    /**
     * Method to fetch the lookup data.
     *
     * @param {object} lookup The lookup object.
     */
    const fetchWardParishData = async (lookup) => {
      const setData = (id, result) => {
        switch (id) {
          case "lookupWards":
            setLookupWards(result);
            wardsLoaded.current = true;
            break;

          case "lookupParishes":
            setLookupParishes(result);
            parishesLoaded.current = true;
            break;

          default:
            break;
        }
      };

      if (lookup.url && lookup.url.url) {
        await fetch(lookup.url.url, {
          headers: lookup.url.headers,
          crossDomain: true,
          method: "GET",
        })
          .then((response) => {
            if (response) {
              switch (response.status) {
                case 200:
                  return response.json();

                case 204:
                  return [];

                case 401:
                  // HandleAuthorisationExpired();
                  setData(lookup.id, lookup.noRecords);
                  break;

                case 500:
                  if (userShowMessages.current)
                    console.error("[500 ERROR] Fetching data", {
                      lookup: lookup.id,
                      errorText: response.statusText,
                      response: response,
                    });
                  setData(lookup.id, lookup.noRecords);
                  break;

                default:
                  if (userShowMessages.current)
                    console.error(`[${response.status} ERROR] Fetching data`, {
                      lookup: lookup.id,
                      errorText: response.statusText,
                      response: response,
                    });
                  setData(lookup.id, lookup.noRecords);
                  break;
              }
            } else return response.json();
          })
          .then((result) => {
            setData(lookup.id, result);
          })
          .catch((e) => {
            // Ignore lookups that do not exist
            if (e.message !== "Unexpected end of JSON input")
              if (userShowMessages.current)
                console.error("[ERROR] Fetching data", {
                  lookup: lookup.id,
                  error: e,
                });
            setData(lookup.id, lookup.noRecords);
          });
      } else {
        // HandleAuthorisationExpired();
        setData(lookup.id, lookup.noRecords);
      }
    };

    /**
     * Method to load the ward and parish lookups
     */
    const LoadWardParishLookups = () => {
      const Lookups = [
        {
          url: GetWardsUrl("GET", currentUserRef.current, Number(authorityDetails.dataProviderCode)),
          noRecords: [],
          id: "lookupWards",
        },
        {
          url: GetParishesUrl("GET", currentUserRef.current, Number(authorityDetails.dataProviderCode)),
          noRecords: [],
          id: "lookupParishes",
        },
      ];

      Lookups.forEach((lookup) => {
        if (!loadedLookups.current.includes(lookup.id)) {
          loadedLookups.current = loadedLookups.current.concat([lookup.id]);
          fetchWardParishData(lookup);
        }
      });
    };

    if (reloadingLookups && authorityDetails && authorityDetails.dataProviderCode) {
      setSpatialReferenceWkid(authorityDetails?.wkid || 27700);
      LoadWardParishLookups();
    }
  }, [authorityDetails, currentUser, reloadingLookups]);

  useEffect(() => {
    if (reloadingLookups) {
      const lookupsAreLoaded =
        validationMessagesLoaded.current &&
        localitiesLoaded.current &&
        townsLoaded.current &&
        islandsLoaded.current &&
        adminAuthoritiesLoaded.current &&
        operationalDistrictsLoaded.current &&
        appCrossRefsLoaded.current &&
        subLocalitiesLoaded.current &&
        postTownsLoaded.current &&
        wardsLoaded.current &&
        parishesLoaded.current &&
        dbAuthoritiesLoaded.current;

      if (lookupsAreLoaded) {
        setLookups({
          validationMessages: lookupValidationMessages,
          localities: lookupLocalities,
          towns: lookupTowns,
          islands: lookupIslands,
          adminAuthorities: lookupAdminAuthorities,
          operationalDistricts: lookupOperationalDistricts,
          appCrossRefs: lookupAppCrossRefs,
          subLocalities: lookupSubLocalities,
          postTowns: lookupPostTowns,
          wards: lookupWards,
          parishes: lookupParishes,
          dbAuthorities: lookupDbAuthorities,
        });
        setReloadingLookups(false);
      }
    }
  }, [
    lookupAdminAuthorities,
    lookupAppCrossRefs,
    lookupDbAuthorities,
    lookupIslands,
    lookupLocalities,
    lookupOperationalDistricts,
    lookupParishes,
    lookupPostTowns,
    lookupSubLocalities,
    lookupTowns,
    lookupValidationMessages,
    lookupWards,
    reloadingLookups,
  ]);

  return (
    <StyledEngineProvider injectFirst>
      <userContext.Provider
        value={{
          currentUser: currentUser,
          onUserChange: HandleUserChange,
          onDisplayLogin: HandleDisplayLogin,
          onExpired: HandleAuthorisationExpired,
          onReload: HandleUserReload,
        }}
      >
        <LookupContext.Provider
          value={{
            currentLookups: lookups,
            metadata: metadata,
            districtUpdated: districtUpdated,
            onLookupChange: HandleLookupChange,
            onUpdateLookup: HandleUpdateLookup,
            onMetadataChange: HandleMetadataChange,
            onDistrictUpdated: HandleDistrictUpdated,
            onReload: HandleLookupReload,
          }}
        >
          <SearchContext.Provider
            value={{
              currentSearchData: searchData,
              previousSearchData: previousSearchData,
              searchPopupOpen: searchOpen,
              hideSearch: hideSearch,
              navigateBack: navigateBack,
              onSearchDataChange: HandleSearchDataChange,
              onPropertiesSelected: HandlePropertiesSelected,
              onSearchOpen: HandleSearchOpenChange,
              onHideSearch: HandleHideSearch,
              onNavigateBack: HandleNavigateBack,
              onReload: HandleSearchReload,
            }}
          >
            <FilterContext.Provider
              value={{
                currentSearchFilter: searchFilter,
                onSearchFilterChange: HandleSearchFilterChange,
                onReload: HandleFilterReload,
              }}
            >
              <SettingsContext.Provider
                value={{
                  currentSettingsNode: settingsNode,
                  authorityDetails: authorityDetails,
                  authorityCode: authorityCode,
                  authorityName: authorityName,
                  isScottish: isScottish,
                  isWelsh: isWelsh,
                  propertyTemplates: propertyTemplates,
                  streetTemplate: streetTemplate,
                  mapLayers: mapLayers,
                  metadataLanguages: metadataLanguages,
                  onNodeChange: HandleNodeChange,
                  onAuthorityDetailsChange: HandleAuthorityDetailsChange,
                  onPropertyTemplatesChange: HandlePropertyTemplatesChange,
                  onStreetTemplateChange: HandleStreetTemplateChange,
                  onMapLayersChange: HandleMapLayersChange,
                  onMetadataLanguagesChanged: HandleMetadataLanguagesChanged,
                  onReload: HandleSettingsReload,
                }}
              >
                <StreetContext.Provider
                  value={{
                    currentStreet: street,
                    creatingStreet: creatingStreet,
                    streetClosing: streetClosing,
                    currentErrors: streetErrors,
                    currentStreetModified: streetModified,
                    currentStreetHasErrors: streetHasErrors,
                    leavingStreet: leavingStreet,
                    goToField: streetGoToField,
                    currentRecord: streetRecord,
                    esuChecked: esuChecked,
                    selectedMapEsuId: selectedMapEsuId,
                    esuDataChanged: esuDataChanged,
                    mergedEsus: mergedEsus,
                    unassignEsus: unassignEsus,
                    assignEsu: assignEsu,
                    assignEsus: assignEsus,
                    createEsus: createEsus,
                    esuDividedMerged: esuDividedMerged,
                    expandedEsu: expandedEsu,
                    expandedAsd: expandedAsd,
                    streetRestored: streetRestored,
                    onStreetChange: HandleStreetChange,
                    onUpdateCurrentStreet: HandleUpdateCurrentStreet,
                    onStreetCreated: HandleStreetCreated,
                    onCloseStreet: HandleCloseStreet,
                    onStreetModified: HandleStreetModified,
                    onStreetErrors: HandleStreetErrors,
                    onLeavingStreet: HandleLeavingStreet,
                    onGoToField: HandleStreetGoToField,
                    onRecordChange: HandleStreetRecordChange,
                    onEsuDataChange: HandleEsuDataChange,
                    onRelatedOpened: HandleStreetRelatedOpened,
                    onEsuCheckedChanged: HandleEsuCheckedChanged,
                    onEsuSelected: HandleEsuSelected,
                    onMergedEsus: HandleMergedEsus,
                    onUnassignEsus: HandleUnassignEsus,
                    onAssignEsu: HandleAssignEsu,
                    onAssignEsus: HandleAssignEsus,
                    onCreateStreet: HandleCreateStreetFromEsus,
                    onEsuDividedMerged: HandleEsuDividedMerged,
                    onToggleEsuExpanded: HandleToggleEsuExpanded,
                    onToggleAsdExpanded: HandleToggleAsdExpanded,
                    resetStreet: HandleResetStreet,
                    restoreStreet: HandleRestoreStreet,
                    storeCurrentStreet: HandleStoreCurrentStreet,
                    resetStreetErrors: HandleResetStreetErrors,
                    validateData: HandleStreetValidateData,
                    onReload: HandleStreetReload,
                  }}
                >
                  <PropertyContext.Provider
                    value={{
                      currentProperty: property,
                      newLogicalStatus: logicalStatus,
                      currentErrors: propertyErrors,
                      rangePropertyErrors: rangePropertyErrors,
                      bulkUpdatePropertiesError: bulkUpdatePropertiesError,
                      currentPropertyModified: propertyModified,
                      currentPropertyHasErrors: propertyHasErrors,
                      leavingProperty: leavingProperty,
                      goToField: propertyGoToField,
                      currentRecord: propertyRecord,
                      childCount: childCount,
                      provenanceDataChanged: provenanceDataChanged,
                      wizardData: wizardData,
                      creatingPropertyRange: creatingPropertyRange,
                      newPropertyRecordType: newPropertyRecordType,
                      onPropertyChange: HandlePropertyChange,
                      onUpdateCurrentProperty: HandleUpdateCurrentProperty,
                      onLogicalStatusChange: HandleLogicalStatusChange,
                      onPropertyModified: HandlePropertyModified,
                      onPropertyErrors: HandlePropertyErrors,
                      onBulkUpdatePropertiesError: HandleBulkUpdatePropertiesError,
                      onLeavingProperty: HandleLeavingProperty,
                      onGoToField: HandlePropertyGoToField,
                      onRecordChange: HandlePropertyRecordChange,
                      onChildCountChange: HandleChildCountChange,
                      onProvenanceDataChange: HandleProvenanceDataChange,
                      onWizardDone: HandleWizardDone,
                      onClearWizardData: HandleClearWizardData,
                      onRelatedOpened: HandlePropertyRelatedOpened,
                      resetProperty: HandleResetProperty,
                      restoreProperty: HandleRestoreProperty,
                      resetPropertyErrors: HandleResetPropertyErrors,
                      validateData: HandlePropertyValidateData,
                      onReload: HandlePropertyReload,
                      onNewPropertyRecordType: setNewPropertyRecordType,
                    }}
                  >
                    <MapContext.Provider
                      value={{
                        spatialReference: spatialReferenceWkid,
                        currentBackgroundData: backgroundData,
                        currentMapSearchData: mapSearchData,
                        sourceSearchData: sourceMapSearchData,
                        currentLayers: map,
                        currentProperty: mapProperty,
                        currentStreet: mapStreet,
                        currentExtent: mapExtent,
                        currentHighlight: highlight,
                        currentEditObject: editObject,
                        currentPropertyPin: mapPropertyPin,
                        currentStreetStart: mapStreetStart,
                        currentStreetEnd: mapStreetEnd,
                        currentDivideEsu: mapDivideEsu,
                        currentWizardPoint: wizardPoint,
                        currentPointCaptureMode: pointCaptureMode,
                        currentLineGeometry: mapLineGeometry,
                        currentPolygonGeometry: mapPolygonGeometry,
                        refreshEsuGeometry: refreshEsuGeometry,
                        refreshProvenance: refreshProvenance,
                        currentPinSelected: selectedPin,
                        selectingProperties: selectingProperties,
                        loadedShpFiles: loadedShpFiles,
                        loadedGeoFiles: loadedGeoFiles,
                        addingShpFile: addShpFilesToMap,
                        addingGeoFile: addGeoFilesToMap,
                        updatingEsuGeometry: updatingEsuGeometry,
                        updatingProvenance: updatingProvenance,
                        createToolActivated: createToolActivated,
                        viewAuthorityExtent: viewAuthorityExtent,
                        updatingData: updatingMap,
                        sketchToolVisibility: sketchToolVisibility,
                        displayingWizardMap: displayingWizardMap,
                        activeBaseMap: activeBaseMap,
                        refreshSketchLayer: refreshSketchLayer,
                        onSpatialReferenceChange: setSpatialReferenceWkid,
                        onBackgroundDataChange: HandleBackgroundDataChange,
                        onSearchDataChange: HandleMapSearchDataChange,
                        onMapChange: HandleMapChange,
                        onEditMapObject: HandleEditMapObject,
                        onMapPropertyChange: HandleMapPropertyChange,
                        onMapStreetChange: HandleMapStreetChange,
                        onExtentChange: HandleExtentChange,
                        onHighlightStreetProperty: HandleStreetPropertyHighlight,
                        onHighlightListItem: HandleListItemHighlight,
                        onHighlightClear: HandleClearHighlight,
                        onSetCoordinate: HandleSetCoordinate,
                        onWizardSetCoordinate: HandleWizardSetCoordinate,
                        onSetLineGeometry: HandleSetLineGeometry,
                        onRefreshEsuGeometry: HandleRefreshEsuGeometry,
                        onSetPolygonGeometry: HandleSetPolygonGeometry,
                        onRefreshPolygonGeometry: HandleRefreshPolygonGeometry,
                        onPointCapture: HandlePointCapture,
                        onPinSelected: HandlePinSelected,
                        onDivideEsu: HandleDivideEsu,
                        onEsuDivided: HandleEsuDivided,
                        onSelectEsus: HandleSelectEsus,
                        onSelectPropertiesChange: HandleSelectPropertiesChange,
                        onLoadShpFile: HandleLoadShpFile,
                        onAddingShpFile: setAddShpFilesToMap,
                        onUnloadShpFile: HandleUnloadShpFile,
                        onLoadGeoFile: HandleLoadGeoFile,
                        onAddingGeoFile: setAddGeoFilesToMap,
                        onUnloadGeoFile: HandleUnloadGeoFile,
                        onReload: HandleMapReload,
                        onUpdatingEsuGeometry: HandleUpdatingEsuGeometry,
                        onUpdatingProvenance: HandleUpdatingProvenance,
                        onCreateToolActivated: HandleCreateToolActivated,
                        onViewAuthorityExtent: HandleViewAuthorityExtent,
                        onDisplayWizardMap: HandleDisplayingWizardMapChange,
                        onActiveBaseMapChange: HandleActiveBaseMapChange,
                        onRefreshSketchLayerChange: setRefreshSketchLayer,
                        onIncreaseDataChange: () => setUpdatingMap((prev) => (prev < 0 ? 1 : prev + 1)),
                        onDecreaseDataChange: () => setUpdatingMap((prev) => (prev > 0 ? prev - 1 : 0)),
                      }}
                    >
                      <InformationContext.Provider
                        value={{
                          informationType: informationType,
                          informationSource: informationSource,
                          onDisplayInformation: HandleDisplayInformation,
                          onClearInformation: HandleClearInformation,
                          onReload: HandleInformationReload,
                        }}
                      >
                        <SelectionContext.Provider
                          value={{
                            selectionVariant: selectionVariant,
                            selectionCount: selectionCount,
                            dialogSelectionCount: dialogSelectionCount,
                            currentStreetSelection: currentStreetSelection,
                            currentEsuSelection: currentEsuSelection,
                            currentPropertySelection: currentPropertySelection,
                            currentAddressSelection: currentAddressSelection,
                            currentClassificationSelection: currentClassificationSelection,
                            currentOrganisationSelection: currentOrganisationSelection,
                            currentSuccessorCrossRefSelection: currentSuccessorCrossRefSelection,
                            currentProvenanceSelection: currentProvenanceSelection,
                            currentExtentSelection: currentExtentSelection,
                            currentCrossReferenceSelection: currentCrossReferenceSelection,
                            streetUsrns: streetUsrns,
                            propertyUprns: propertyUprns,
                            copyOpen: copyOpen,
                            addNote: addNote,
                            editWizard: editWizard,
                            selectionError: selectionError,
                            deleteClassification: deleteClassification,
                            deleteOrganisation: deleteOrganisation,
                            deleteSuccessorCrossRef: deleteSuccessorCrossRef,
                            deleteProvenance: deleteProvenance,
                            mergeExtent: mergeExtent,
                            deleteCrossReference: deleteCrossReference,
                            deleteWizard: deleteWizard,
                            propertyMoved: propertyMoved,
                            closeControl: closeControl,
                            onSelectionVariantChange: HandleSelectionVariantChange,
                            onSelectionCountChange: setSelectionCount,
                            onDialogSelectionCountChange: setDialogSelectionCount,
                            onCurrentStreetChange: setCurrentStreetSelection,
                            onCurrentEsuChange: setCurrentEsuSelection,
                            onCurrentPropertyChange: setCurrentPropertySelection,
                            onCurrentAddressChange: setCurrentAddressSelection,
                            onCurrentClassificationChange: setCurrentClassificationSelection,
                            onCurrentOrganisationChange: setCurrentOrganisationSelection,
                            onCurrentSuccessorCrossRefChange: setCurrentSuccessorCrossRefSelection,
                            onCurrentProvenanceChange: setCurrentProvenanceSelection,
                            onCurrentExtentChange: setCurrentExtentSelection,
                            onCurrentCrossReferenceChange: setCurrentCrossReferenceSelection,
                            onStreetUsrnsChange: setStreetUsrns,
                            onPropertyUprnsChange: setPropertyUprns,
                            onSetCopyOpen: setCopyOpen,
                            onAddNote: setAddNote,
                            onEditWizard: setEditWizard,
                            onError: setSelectionError,
                            onDeleteClassification: setDeleteClassification,
                            onDeleteOrganisation: setDeleteOrganisation,
                            onDeleteSuccessorCrossRef: setDeleteSuccessorCrossRef,
                            onDeleteProvenance: setDeleteProvenance,
                            onMergeExtent: setMergeExtent,
                            onDeleteCrossReference: setDeleteCrossReference,
                            onDeleteWizard: setDeleteWizard,
                            onPropertyMoved: setPropertyMoved,
                            onCloseSelection: HandleCloseSelection,
                            onControlClosed: () => setCloseControl(false),
                          }}
                        >
                          <SaveConfirmationServiceProvider>
                            <ThemeProvider theme={theme}>
                              <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <Online polling={onlinePolling}>
                                  <Fragment>
                                    <div style={{ display: "flex" }}>
                                      <CssBaseline />
                                      <ADSAppBar />
                                      <ADSNavContent uprn={property.uprn} />
                                      <main
                                        style={{
                                          flexGrow: 1,
                                          pl: "0px",
                                          pr: "0px",
                                        }}
                                      >
                                        <div style={{ height: `${appBarHeight}px` }} />
                                        {currentUser && <Outlet />}
                                      </main>
                                    </div>
                                    <LoginDialog
                                      isOpen={loginOpen}
                                      title="iManage GMS Login"
                                      message={loginMessage.current}
                                    />
                                  </Fragment>
                                </Online>
                                <Offline polling={offlinePolling}>
                                  <Box
                                    sx={{
                                      paddingTop: "30px",
                                      textAlign: "center",
                                      backgroundColor: adsLightGreyD,
                                      height: "100vh",
                                    }}
                                  >
                                    <Stack
                                      direction="column"
                                      spacing={2}
                                      justifyContent="center"
                                      alignItems="center"
                                      sx={{ height: "100vh" }}
                                    >
                                      <WifiOffIcon sx={{ height: "100px", width: "100px" }} />
                                      <Typography variant="h1" sx={{ marginBottom: "5px" }}>
                                        Couldn't connect
                                      </Typography>
                                      <Typography variant="h4" sx={{ margin: "0" }}>
                                        Check your internet connection and try again.
                                      </Typography>
                                    </Stack>
                                  </Box>
                                </Offline>
                              </LocalizationProvider>
                            </ThemeProvider>
                          </SaveConfirmationServiceProvider>
                        </SelectionContext.Provider>
                      </InformationContext.Provider>
                    </MapContext.Provider>
                  </PropertyContext.Provider>
                </StreetContext.Provider>
              </SettingsContext.Provider>
            </FilterContext.Provider>
          </SearchContext.Provider>
        </LookupContext.Provider>
      </userContext.Provider>
    </StyledEngineProvider>
  );
}

export default App;
